<template>
  <div class="timesheet-popover" style="max-height:410px;overflow-y:auto;overflow-x:hidden">
    <template v-if="IsReject">
      <div class="popper-content-holder" style="display: inline-block;padding: 5px 10px;">
        <div class="col-md-12 p0 clearfix">
          <span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_reject.svg`" style="width:4px;" /></span>
          <span class="timesheet-title">Reject Leave</span>
        </div>
        <div class="col-md-12 p0 clearfix" style="margin-bottom: 14px;margin-top: 10px;">
          <label class="control-label">Reject Reason</label>
          <ob-textarea :maxLength="1200" v-model="LeaveRejectReason"></ob-textarea>
        </div>
        <div class="col-md-12 p0 footer-content">
          <span @click.stop="onBackFromReject" style="font-size: 12px; cursor: pointer;color:#35373A">Back</span> |
          <span @click="onRejectLeave"
            :class="{ 'editDisable': (LeaveRejectReason == '' || LeaveRejectReason == null) }"
            style="font-size: 12px;color: #4A90E2; cursor: pointer;">Submit</span>
        </div>
      </div>
    </template>
    <template v-else-if="IsRevoke">
      <div class="popper-content-holder" style="display: inline-block;padding: 5px 10px;">
        <div class="col-md-12 p0 clearfix">
          <span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_reject.svg`" style="width:4px;" /></span>
          <span class="timesheet-title">Revoke Leave</span>
        </div>
        <div class="col-md-12 p0 clearfix" style="margin-bottom: 14px;margin-top: 10px;">
          <label class="control-label">Revoke Reason</label>
          <ob-textarea :maxLength="1200" v-model="LeaveRevokeReason"></ob-textarea>
        </div>
        <div class="col-md-12 p0 footer-content">
          <span @click.stop="onBackFromRevoke" style="font-size: 12px; cursor: pointer;color:#35373A">Back</span> |
          <span @click="onRevokeLeave"
            :class="{ 'editDisable': (LeaveRevokeReason == '' || LeaveRevokeReason == null) }"
            style="font-size: 12px;color: #4A90E2; cursor: pointer;">Submit</span>
        </div>
      </div>
    </template>
    <template v-else v-for="(Event, i) in eventList">
      <div style="display: inline-block;padding: 5px 10px;" class="event-block">
        <template v-if="Event.CalendarType == 'Leave' && Event.Status == 'Pending'">
          <div class="popper-content-holder">
            <div class="col-md-9 p0" style="margin-bottom:2px;">
              <span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_pending-leave.svg`" style="width:4px;" /></span>
              <span class="timesheet-title">Pending Leave Approval</span>
            </div>
            <div class="col-md-2 clearfix">
              <a v-if="IsEmployeeView" @click.stop="IsRevoke = true ; selectedEvent = Event"
                class="revokeStyles">Revoke</a>
            </div>
            <div class="col-md-12 p0" style="margin-bottom:4px;">
              <div class="col-md-7 pL0 pR0">
                <label class="control-label" style="margin-bottom:2px !important">Leave Range</label>
                <p v-if="Event.NoofDays > 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
              </div>
              <div class="col-md-5 pL0 pR0">
                <label class="control-label" style="margin-bottom:2px !important">Time Off Code</label>
                <p class="static" v-if="Event.LeaveTypeList != null && Event.LeaveTypeList.length > 1">{{ getLeaveType(Event.LeaveTypeList) }}</p>
                <p class="static" v-else>{{ Event.LeaveType }}</p>
              </div>
            </div>
            <div class="col-md-12 p0" style="margin-bottom:6px;">
              <label class="control-label" style="margin-bottom:2px !important">Leave Reason</label>
              <p class="static" style="max-height:200px;overflow-x:auto;">{{ Event.LeaveReason }}</p>
            </div>
            <div class="col-md-12 p0" v-if="Event.IsTravellingOut == true">
              <h5 style="font-weight:500:font-size:12px;"><b>Note: Travelling out of country</b></h5>
            </div>
            <div class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
              <template v-for="(item, index) in Event.AttachmentUrls">
                <div class="timesheet-attachments" v-if="item != '' && item != null">
                  <span class="fileName">{{ item | I9URL2FileName }}</span>
                  <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                    <div class="popper" style="padding:0px">
                      <div style="padding:10px;">
                        <span :class="{ 'cursorCls': !isFileType(item) }">
                          <span :class="{ 'hideShow': !isFileType(item) }"
                            style="display:inline-block;padding-right:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                              @click="printSingleDoc(item)" /></span>
                        </span>
                        <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                            :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                            @click="downloadSingleDoc(item)" /></span>
                        <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                            :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                            @click="previewSingleDoc(item)" /></span>
                      </div>
                    </div>
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference"
                      style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                  </ob-popover>
                  <!-- <span >
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_newtab-link.svg`" style="cursor: pointer;margin-bottom:7px;"/>
                      </span> -->
                </div>
              </template>
            </div>
            <div class="col-md-12 p0 footer-content" v-if="!IsEmployeeView">
              <span @click="onLeaveApprove(Event)"
                style="font-size: 12px;color: #4DBB74; cursor: pointer;">Approve</span> | <span
                @click="IsReject = true ; selectedEvent = Event"
                style="font-size: 12px;color: #F0525A; cursor: pointer;">Reject</span>
            </div>
          </div>
        </template>
        <template v-else-if="Event.CalendarType == 'Leave' && Event.Status == 'Approved'">
          <div class="popper-content-holder1">
            <div class="col-md-9 p0 clearfix">
              <span style="padding-right:0px;"><span class="circle"></span></span>
              <span class="timesheet-title">Approved by {{ Event.ApprovedBy.CurrentRole == 'HRManager' ? "HR Manager" : Event.ApprovedBy.CurrentRole }}</span>
            </div>
            <div class="col-md-2 clearfix">
              <a v-if="!IsEmployeeView" @click.stop="IsRevoke = true ; selectedEvent = Event"
                class="revokeStyles">Revoke</a>
            </div>
            <div class="col-md-12 p0 clearfix" style="margin-bottom: 6px;">
              <div class="emp-list clearfix">
                <div class="col-md-12 p0 active-index" style="padding-left: 0px;margin-top: 10px; cursor: pointer;">
                  <div class="media">
                    <div class="media-left" style="width: 45px;"><img
                        :src="Event.ApprovedBy.ProfilePicLink != null && Event.ApprovedBy.ProfilePicLink != '' ? Event.ApprovedBy.ProfilePicLink : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`"
                        style="width: 35px; height: 35px; border-radius: 50%;"></div>
                    <div class="media-right">
                      <span style="font-size:14px ; font-weight: 600;">{{ Event.ApprovedBy.Name }}</span> <br>
                      <span style="font-size:12px">{{ Event.ApprovedBy.Designation == 'HRManager' ? 'HR Manager' : Event.ApprovedBy.Designation }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 p0" style="margin-bottom:4px;">
              <div class="col-md-9 pL0 pR0">
                <label class="control-label" style="margin-bottom:2px !important">Leave Range</label>
                <p v-if="Event.NoofDays > 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
              </div>
              <div class="col-md-3 pL0 pR0">
                <label class="control-label" style="margin-bottom:2px !important">Time Off Code</label>
                <p class="static" v-if="Event.LeaveTypeList != null && Event.LeaveTypeList.length > 1">{{ getLeaveType(Event.LeaveTypeList) }}</p>
                <p class="static" v-else>{{ Event.LeaveType }}</p>
              </div>
            </div>
            <div class="col-md-12 p0" style="margin-bottom:6px;">
              <label class="control-label" style="margin-bottom:2px !important">Leave Reason</label>
              <p class="static" style="max-height:200px;overflow-x:auto;">{{ Event.LeaveReason }}</p>
            </div>
            <div class="col-md-12 p0" v-if="Event.IsTravellingOut == true">
              <h5 style="font-weight:500:font-size:12px;"><b>Note: Travelling out of country</b></h5>
            </div>
            <div class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
              <template v-for="(item, index) in Event.AttachmentUrls">
                <div class="timesheet-attachments" v-if="item != '' && item != null">
                  <span class="fileName">{{ item | I9URL2FileName }}</span>
                  <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                    <div class="popper" style="padding:0px">
                      <div style="padding:10px;">
                        <span :class="{ 'cursorCls': !isFileType(item) }">
                          <span :class="{ 'hideShow': !isFileType(item) }"
                            style="display:inline-block;padding-right:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                              @click="printSingleDoc(item)" /></span>
                        </span>
                        <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                            :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                            @click="downloadSingleDoc(item)" /></span>
                        <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                            :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                            @click="previewSingleDoc(item)" /></span>
                      </div>
                    </div>
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference"
                      style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                  </ob-popover>
                  <!-- <span >
                              <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_newtab-link.svg`" style="cursor: pointer;margin-bottom:7px;"/>
                            </span> -->
                </div>
              </template>
            </div>
            <div class="col-md-12 p0 footer-content">
              <span class="static"> Approved on {{ getDateFormat(Event.ApprovedDate) }} {{ getMonthName(Event.ApprovedDate) }}</span>
            </div>
          </div>
        </template>
        <template
          v-else-if="Event.CalendarType == 'TimeSheet' && Event.TimesheetType != 'TimesheetExpense' && (Event.Status == 'Pending' || Event.ExpenseStatus == 'Pending')">
          <div class="popper-content-holder">
            <div v-if="Event.HoursWorked != '' && Event.Status == 'Pending'">
              <div class="col-md-12 p0 clearfix">
                <ul class="clearfix list-unstyled list-inline">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li>Timesheet</li>
                    <!-- <li style="padding-right:0px;"><span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_pending.svg`" /></span></li> -->
                    <li id="distance"
                      v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'">
                      <span class="timesheet-title" v-if="IsEmployeeView" style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px"
                      >Pending (request to re-submit) </span>
                      <span class="timesheet-title" v-else style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px"
                      >Pending Submission</span>
                    </li>
                    <li id="distance" v-else>
                      <span class="timesheet-title" style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px"
                      >Pending Approval</span>
                    </li>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="IsEmployeeView">
                    <li>
                      <span v-if="Event.InvoiceStatus != 'Invoice Generated'" @click="edit(Event)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    </li>
                    <li>
                      <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </li>
                  </ul> -->
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item
                      v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'"
                      @click.native="edit(Event, 'timesheet')">Re-Submit</ob-dropdown-list-item>
                    <ob-dropdown-list-item v-else-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'timesheet')">Update</ob-dropdown-list-item>
                    <ob-dropdown-list-item v-if="(Event.Status == 'Approved' || Event.Status == 'Pending' ) && (Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployerRequestToResubmit')"
                      @click.native="openSelectReportPopup(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item>
                    <!-- <ob-dropdown-list-item v-if="Event.Status == 'Approved'"
                      @click.native="viewReport(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;"
                    v-if="!IsEmployeeView && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'"> -->
                    <ob-dropdown type="ellipsis" class="pull-right clearfix " v-if="!IsEmployeeView && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'" >
                      <ob-dropdown-list-item @click.native="approval(Event, true, 'timesheet')">Edit</ob-dropdown-list-item>
                      <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span @click="approval(Event, true, 'timesheet')"><i class="fa fa-pencil"
                          aria-hidden="true"></i></span>
                    </li> -->
                  <!-- </ul> -->
                  <ul class="pull-right clearfix ">
                    <!-- <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span> -->
                    <template v-if="!IsEmployeeView">
                      <span
                        v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployerRequestToResubmit'">
                        <ob-dropdown type="ellipsis" class="pull-right clearfix ">
                          <ob-dropdown-list-item @click.native="approval(Event, true, 'timesheet')">Verify</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="approval(Event, false, 'timesheet')">Approve</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="openSelectReportPopup(Event.Id, 'timesheet')">View Report</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                        </ob-dropdown>
                        <!-- <span @click="approval(Event, true, 'timesheet')"
                          style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span
                          @click="approval(Event, false, 'timesheet')"
                          style="font-size: 12px;color:  #4A90E2; cursor: pointer;">Approve</span> -->
                      </span>
                    </template>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && !IsEmployeeView">
                    <li>
                      <span style="font-size: 12px;color: #4A90E2; cursor: pointer;" @click="openRemindApprover(Event)">Remind Approver</span>
                    </li>
                  </ul> -->
                </ul>
              </div>
              <!--<div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 8px;">
                <div class="col-md-3">
                  <label class="timesheet-label">Hours Worked</label>
                  <p class="static">{{ Event.HoursWorked }}</p>
                </div>
                <div class="col-md-4 mL0"
                  v-if="Event.SubmittedDate != null && Event.SubmittedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                  <label class="timesheet-label">Submitted Date</label><span class="edit_date" v-if="Event.isSubmitDate"
                    @click.stop="updateDates(Event)">Save</span>
                  <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                      :inputvalue="Event.SubmittedDate" :options="subOptions(Event)"
                      @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker>
                  </div>
                  <div v-else>
                    <p class="static">{{ Event.SubmittedDate }}<span @click.stop="Event.isSubmitDate = true"
                        v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                          style="padding-left:4px;"></i></span></p>
                  </div>
                </div>
                <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                  v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit' && Event.TimesheetlatestLog.AuthorizedBy != null && Event.TimesheetlatestLog.AuthorizedBy.Name != null && Event.TimesheetlatestLog.AuthorizedBy.Name != ''"
                  ><label class="timesheet-label">Re-submit requested by</label><p class="static">{{ Event.TimesheetlatestLog.AuthorizedBy.Name }} on {{ Event.TimesheetlatestLog.DateTime }}</p>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;" v-if="Event.IsReSubmitted && Event.ReSubmittedBy.Name != null && Event.ReSubmittedBy.Name != ''">
                <div class="col-md-10 pL0 pR0">
                  <label class="timesheet-label">Re-submit requested by</label>
                  <p class="static">{{Event.ReSubmittedBy.Name}}</p>
                </div>
              </div> -->
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit' && Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Re-submit reason</label>
                  <p class="static">{{ Event.TimesheetlatestLog.Comment }}</p>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_newtab-link.svg`" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''"
                class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                <div class="col-md-12 p0 clearfix">
                  <div class="col-md-12 p0 clearfix">
                    <span style="padding-right:0px;"><span class="circle2"></span></span>
                    <span id="distance"><span class="timesheet-title">Shared Information</span></span>
                  </div>
                  <template v-for="(item, index) in Event.TimesheetSharedLogModel">
                    <div class="col-md-12 p0 clearfix">
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Recipient Email</label>


                        <template v-for="(Item, Index) in item.SharedTo">
                          <p v-if="Index < 2 || item.showSharedLog" class="static"
                            style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                            :title="Item">{{ Item }}</p>
                        </template>
                        <a style="font-size: 11px;float: right;margin-right: 50px;"
                          v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)"
                          @click.stop="$set(item, 'showSharedLog', true)">{{ item.SharedTo.length - 2 }} more <i
                            class="fa fa-angle-down"></i> </a>
                      </div>
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Date & Time</label>
                        <p class="static"
                          style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                          :title="item.SharedDateTime">{{ item.SharedDateTime }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                  <div class="col-md-4 pR0"
                    v-if="!IsEmployeeView && Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployerRequestToResubmit'">
                    <span style="font-size: 12px;color: #4A90E2; cursor: pointer;"
                      @click="openRemindApprover(Event, 'Timesheet')">Remind Approver</span>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                <template  v-else>
                  <span v-if="!Event.IsReSubmitted" >
                  <span @click="approval(Event,true)" style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span  @click="approval(Event,false)" style="font-size: 12px;color:  #4A90E2; cursor: pointer;" >Approve</span>
                  </span>
                </template>
              </div> -->
            </div>
            <div
              v-if="Event.SubmittedExpenseAmount != null && Event.SubmittedExpenseAmount != '' && Event.SubmittedExpenseAmount > 0">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <ul class="clearfix list-unstyled list-inline" style="margin-top:2%">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li>Expenses</li>
                    <li id="distance"
                      v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'">
                      <span class="timesheet-title" v-if="IsEmployeeView"
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending (request to re-submit)</span>
                      <span class="timesheet-title" v-else
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending Submission</span>
                    </li>
                    <li id="distance" v-else><span class="timesheet-title"
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending Approval</span></li>
                  </ul>
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item
                      v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'"
                      @click.native="edit(Event, 'expense')">Resubmit</ob-dropdown-list-item>
                    <ob-dropdown-list-item v-else-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'expense')">Update</ob-dropdown-list-item>
                    <!-- <ob-dropdown-list-item @click.native="viewReport(Event.Id,'Expense')">View Report</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item @click.native="openSelectReportPopup(Event.Id, 'Expense')">View Report</ob-dropdown-list-item>

                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;"
                    v-if="!IsEmployeeView && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'"> -->
                    <ob-dropdown type="ellipsis" class="pull-right clearfix " v-if="!IsEmployeeView && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'" >
                      <ob-dropdown-list-item @click.native="approval(Event, true, 'expense')">Edit</ob-dropdown-list-item>
                      <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span @click="approval(Event, true, 'expense')"><i class="fa fa-pencil"
                          aria-hidden="true"></i></span>
                    </li> -->
                  <!-- </ul> -->
                  <ul class="pull-right clearfix ">
                    <!-- <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span> -->
                    <template v-if="!IsEmployeeView">
                      <span v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployerRequestToResubmit'">
                        <ob-dropdown type="ellipsis" class="pull-right clearfix ">
                          <ob-dropdown-list-item @click.native="approval(Event, true, 'expense')">Verify</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="approval(Event, false, 'expense')">Approve</ob-dropdown-list-item>
                                            <ob-dropdown-list-item @click.native="openSelectReportPopup(Event.Id, 'Expense')">View Report</ob-dropdown-list-item>

                          <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                        </ob-dropdown>
                        <!-- <span @click="approval(Event, true, 'expense')"
                          style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span
                          @click="approval(Event, false, 'expense')"
                          style="font-size: 12px;color:  #4A90E2; cursor: pointer;">Approve</span>-->
                      </span>
                    </template>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && !IsEmployeeView">
                    <li>
                      <span style="font-size: 12px;color: #4A90E2; cursor: pointer;" @click="openRemindApprover(Event)">Remind Approver</span>
                    </li>
                  </ul> -->
                </ul>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expense Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 8px;">
                <div class="col-md-3">
                  <label class="timesheet-label">ExpenseAmount</label>
                  <p class="static">$ {{ Number((Event.SubmittedExpenseAmount).toFixed(2)) }}</p>
                </div>
                <!-- <div class="col-md-3 pL0 mL0">
                  <label class="timesheet-label">Expense Type</label>
                  <p class="static">$ {{Number((Event.SubmittedExpenseAmount).toFixed(2))}}</p>
                </div> -->
                <!-- <div class="col-md-3 pL0 mL0">
                  <label class="timesheet-label">Payment Type</label>
                  <p class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;" :title="Event.PaymentType">{{NAOrValue(Event, 'PaymentType')}}</p>
                </div> -->
                <div class="col-md-4 mL0" v-if="Event.ExpenseSubmittedDate != null && Event.ExpenseSubmittedDate != ''">
                  <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                    v-if="Event.isExpenseSubmitDate" @click.stop="updateExpenseDates(Event)">Save</span>
                  <div v-if="Event.isExpenseSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                      :inputvalue="Event.ExpenseSubmittedDate" :options="ExpensesubOptions(Event)"
                      @updated="(v) => Event.ExpenseSubmittedDate = v"
                      v-model="Event.ExpenseSubmittedDate"></ob-date-time-picker></div>
                  <div v-else>
                    <p class="static">{{ Event.ExpenseSubmittedDate }}<span
                        @click.stop="Event.isExpenseSubmitDate = true" v-if="!IsEmployeeView"><i
                          class="fa fa-pencil image" aria-hidden="true" style="padding-left:4px;"></i></span></p>
                  </div>
                </div>
                <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                  v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit' && Event.ExpenselatestLog.AuthorizedBy != null && Event.ExpenselatestLog.AuthorizedBy.Name != null && Event.ExpenselatestLog.AuthorizedBy.Name != ''">
                  <label class="timesheet-label">Re-submit requested by</label>
                  <p class="static">{{ Event.ExpenselatestLog.AuthorizedBy.Name }} on {{ Event.ExpenselatestLog.DateTime }}</p>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit' && Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Re-submit reason</label>
                  <p class="static">{{ Event.ExpenselatestLog.Comment }}</p>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;">
                <div class="col-md-3 pL0 pR0" v-if="Event.SubmittedDate != null && Event.SubmittedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                  <label class="timesheet-label">Submitted Date</label><span class="edit_date" v-if="Event.isSubmitDate" @click.stop="updateDates(Event)">Save</span>
                  <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4'+Event.Id" :inputvalue="Event.SubmittedDate" :options="subOptions(Event)" @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker></div>
                  <div v-else><p class="static">{{Event.SubmittedDate}}<span @click.stop="Event.isSubmitDate = true" v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:4px;"></i></span></p></div>
                </div>
              </div> -->
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_newtab-link.svg`" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <!-- <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''" class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                  <div class="col-md-12 p0 clearfix">
                      <div class="col-md-12 p0 clearfix">
                        <span style="padding-right:0px;"><span class="circle2"></span></span>
                        <span id="distance"><span class="timesheet-title"> Shared Information</span></span>
                      </div>
                      <template v-for="(item,index) in Event.TimesheetSharedLogModel">
                        <div class="col-md-12 p0 clearfix">
                          <div class="col-md-6 p0">
                            <label class="timesheet-label"> Recipient Email</label>


                            <template v-for="(Item,Index) in item.SharedTo">
                              <p v-if="Index < 2 || item.showSharedLog " class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;" :title="Item">{{Item}}</p>
                            </template>
                             <a  style="font-size: 11px;float: right;margin-right: 50px;" v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)" @click.stop="$set(item, 'showSharedLog', true)">{{item.SharedTo.length - 2 }} more <i class="fa fa-angle-down"></i> </a>
                          </div>
                          <div class="col-md-6 p0">
                            <label class="timesheet-label"> Date & Time</label>
                            <p class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;" :title="item.SharedDateTime">{{item.SharedDateTime}}</p>
                         </div>
                        </div>
                      </template>
                  </div>
              </div> -->
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                  <div class="col-md-4 pR0"
                    v-if="!IsEmployeeView && Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployerRequestToResubmit'">
                    <span style="font-size: 12px;color: #4A90E2; cursor: pointer;"
                      @click="openRemindApprover(Event, 'Expense')">Remind Approver</span>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                <template  v-else>
                  <span v-if="!Event.IsReSubmitted" >
                  <span @click="approval(Event,true)" style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span  @click="approval(Event,false)" style="font-size: 12px;color:  #4A90E2; cursor: pointer;" >Approve</span>
                  </span>
                </template>
              </div> -->
            </div>

          </div>
        </template>
        <template
          v-else-if="Event.CalendarType == 'TimeSheet' && Event.TimesheetType != 'TimesheetExpense' && (Event.Status == 'Rejected' || Event.ExpenseStatus == 'Rejected')">
          <div class="popper-content-holder">
            <div v-if="Event.Status == 'Rejected' && Event.HoursWorked != ''">
              <div class="col-md-12 p0 clearfix">
                <ul class="clearfix list-unstyled list-inline">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Timesheet</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#fdeae5;color:#EF4457;font-size:10px;padding:3px 6px">Rejected</span>
                    </li>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
                    <li>
                      <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </li>
                  </ul> -->
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <!-- <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.TimesheetId, 'Timesheet')">Delete</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item
                      @click.native="reSubmit(Event, 'timesheet')">Re-Submit</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul v-else-if="!IsEmployeeView" class="pull-right clearfix list-unstyled list-inline"
                    style="margin:0px;"> -->
                    <ob-dropdown v-else-if="!IsEmployeeView" type="ellipsis" class="pull-right clearfix ">
                      <ob-dropdown-list-item @click.native="approval(Event, true, 'timesheet')">Edit</ob-dropdown-list-item>
                      <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span :class="{ 'disable-options': isTimeSheetsWriteAccessRestricted }"
                        @click="approval(Event, true, 'timesheet')"><i class="fa fa-pencil"
                          aria-hidden="true"></i></span>
                    </li>
                  </ul> -->
                </ul>
              </div>
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <!-- <div class="col-md-6">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} day)</p>
                    <p v-else class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} days)</p>
                  </div> -->
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Hours Worked</label>
                    <p class="static">{{ Event.HoursWorked }}</p>
                  </div>
                  <div class="col-md-4 mL0" v-if="Event.SubmittedDate != null && Event.SubmittedDate != ''">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isSubmitDate && !Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                    <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.SubmittedDate" :options="subOptions(Event)"
                        @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker>
                    </div>
                    <div v-else>
                      <p class="static">{{ Event.SubmittedDate }}<span @click.stop="editSubmittedDate(Event)"
                          v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                            style="padding-left:6px;"
                            :class="{ 'editDisable': disableSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <!-- <div class="col-md-5 pL0 mL0" v-if="Event.ApprovedDate != null && Event.ApprovedDate != ''">
                  <label class="timesheet-label">Approval Date</label><span class="edit_date" v-if="!Event.isSubmitDate && Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                  <div v-if="Event.isApprovalDate"><ob-date-time-picker :id="'date5'+Event.Id" :inputvalue="Event.ApprovedDate" :options="appOptions(Event.SubmittedDate)" @updated="(v) => Event.ApprovedDate = v" v-model="Event.ApprovedDate"></ob-date-time-picker></div>
                  <div v-else><p class="static">{{Event.ApprovedDate}}<span @click.stop="editApprovedDate(Event)" v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;" :class="{ 'editDisable': disableApprovedDateEdit(Event)}"></i></span></p></div>
                </div> -->
                  <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                    v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'Rejected' && Event.TimesheetlatestLog.DateTime != null">
                    <label class="timesheet-label">Rejected Date</label>
                    <p class="static">{{ Event.TimesheetlatestLog.DateTime }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'Rejected' && Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Reason for Rejection</label>
                  <p class="static">{{ Event.TimesheetlatestLog.Comment }}</p>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-if="Event.SubmittedExpenseAmount != null && Event.SubmittedExpenseAmount != '' && Event.SubmittedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.SubmittedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-else-if="Event.ApporvedExpenseAmount != null && Event.ApporvedExpenseAmount != '' && Event.ApporvedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.ApporvedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div> -->
              <!-- <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''" class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item,index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments"  v-if="item!= '' && item != null"  >
                    <span class="fileName">
                      {{item  | I9URL2FileName}}
                    </span>
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div style="padding:10px;">
                                <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                              </span>
                                <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                                <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                            </div>
                        </div>
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div> -->
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" 
                      :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;"><span class="accept" @click="reSubmit(Event)">Re-Submit</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
              </div> -->
            </div>
            <div v-if="Event.ExpenseStatus == 'Rejected' && (Event.RejectedExpenseAmount > 0)">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <ul class="clearfix list-unstyled list-inline" style="margin-top:2%">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Expenses</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#fdeae5;color:#EF4457;font-size:10px;padding:3px 6px">Rejected</span>
                    </li>
                  </ul>
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <!-- <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.ExpenseId, 'Expense')">Delete</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item @click.native="reSubmit(Event, 'expense')">Re-Submit</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul v-else-if="!IsEmployeeView" class="pull-right clearfix list-unstyled list-inline"
                    style="margin:0px;"> -->
                    <ob-dropdown type="ellipsis" class="pull-right clearfix " v-else-if="!IsEmployeeView">
                      <ob-dropdown-list-item @click.native="approval(Event, true, 'expense')">Edit</ob-dropdown-list-item>
                      <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span :class="{ 'disable-options': isTimeSheetsWriteAccessRestricted }"
                        @click="approval(Event, true, 'expense')"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    </li> -->
                  <!-- </ul> -->
                </ul>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expense Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3"
                    v-if="Event.RejectedExpenseAmount != null && Event.RejectedExpenseAmount != '' && Event.RejectedExpenseAmount > 0">
                    <label class="timesheet-label">Expense Amount</label>
                    <p class="static">$ {{ Number((Event.RejectedExpenseAmount).toFixed(2)) }}</p>
                  </div>
                  <div class="col-md-4 mL0"
                    v-if="Event.ExpenseSubmittedDate != null && Event.ExpenseSubmittedDate != ''">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isExpenseSubmitDate && !Event.isExpenseApprovalDate"
                      @click.stop="updateExpenseDates(Event)">Save</span>
                    <div v-if="Event.isExpenseSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.ExpenseSubmittedDate" :options="ExpensesubOptions(Event)"
                        @updated="(v) => Event.ExpenseSubmittedDate = v"
                        v-model="Event.ExpenseSubmittedDate"></ob-date-time-picker></div>
                    <div v-else>
                      <p class="static">{{ Event.ExpenseSubmittedDate }}<span
                          @click.stop="editExpenseSubmittedDate(Event)" v-if="!IsEmployeeView"><i
                            class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;"
                            :class="{ 'editDisable': disableExpenseSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <!-- <div class="col-md-5 pL0 mL0" v-if="Event.ExpenseApprovedDate != null && Event.ExpenseApprovedDate != ''">
                  <label class="timesheet-label">Approval Date</label><span class="edit_date" v-if="!Event.isExpenseSubmitDate && Event.isExpenseApprovalDate" @click.stop="updateExpenseDates(Event)">Save</span>
                  <div v-if="Event.isExpenseApprovalDate"><ob-date-time-picker :id="'date5'+Event.Id" :inputvalue="Event.ExpenseApprovedDate" :options="appOptions(Event.ExpenseSubmittedDate)" @updated="(v) => Event.ExpenseApprovedDate = v" v-model="Event.ExpenseApprovedDate"></ob-date-time-picker></div>
                  <div v-else><p class="static">{{Event.ExpenseApprovedDate}}<span @click.stop="editExpenseApprovedDate(Event)" v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;" :class="{ 'editDisable': disableExpenseApprovedDateEdit(Event)}"></i></span></p></div>
                </div> -->
                  <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                    v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'Rejected' && Event.ExpenselatestLog.DateTime != null">
                    <label class="timesheet-label">Rejected Date</label>
                    <p class="static">{{ Event.ExpenselatestLog.DateTime }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'Rejected' && Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Reason for Rejection</label>
                  <p class="static">{{ Event.ExpenselatestLog.Comment }}</p>
                </div>
              </div>
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="item in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">
                      {{ item | I9URL2FileName }}
                    </span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template
          v-else-if="Event.CalendarType == 'TimeSheet' && Event.TimesheetType != 'TimesheetExpense' && (Event.Status == 'Approved' || Event.ExpenseStatus == 'Approved')">
          <div class="popper-content-holder">
            <div v-if="Event.HoursWorked != '' && Event.Status == 'Approved'">
              <div class="col-md-12 p0 clearfix">
                <span style="padding-right:10px;">Timesheet</span>
                <!-- <span style="padding-right:0px;"><span class="circle2"></span></span> -->
                <span id="distance">
                  <span v-if="Event.TimesheetlatestLog && Event.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit'" class="timesheet-title" style="border-radius:10px;background-color:#eee7ff;color:#aa99d6;font-size:10px;padding:3px 6px">Requested for Edit</span>
                  <span v-else class="timesheet-title" style="border-radius:10px;background-color:#e7fbf2;color:#13da7c;font-size:10px;padding:3px 6px">Approved</span></span>
                <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="Event.InvoiceStatus != 'Invoice Generated'">
                  <li v-if="IsEmployeeView">
                    <span v-if="IsEditTimesheetFlag" @click="edit(Event)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                  </li>
                  <li v-else>
                    <span @click="approval(Event,true)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                  </li>
                  <li v-if="IsEmployeeView">
                    <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                  </li>
                </ul> -->
                <ob-dropdown type="ellipsis" class="pull-right clearfix "
                  v-if="Event.InvoiceStatus != 'Invoice Generated'">
                  <ob-dropdown-list-item v-if="IsEmployeeView && IsEditTimesheetFlag"
                    @click.native="edit(Event, 'timesheet')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-else-if="!IsEmployeeView"
                    @click.native="approval(Event, true, 'timesheet')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="!IsEditTimesheetFlag && !IsEmployeeView && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForReSubmitPopUp(Event, 'Timesheet')">Request for re-submit</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="IsEmployeeView && !IsEditTimesheetFlag && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForEditPopup(Event, 'Timesheet')">Request for Edit</ob-dropdown-list-item>
                  <!-- <ob-dropdown-list-item @click.native="viewReport(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item> -->
                  <ob-dropdown-list-item v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployeeRequestedForEdit'" @click.native="openSelectReportPopup(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-if="!IsEmployeeView"  @click.native="deleteTimesheetM(Event.Id,'Timesheet')">Delete</ob-dropdown-list-item>
                </ob-dropdown>
                <ul v-if="Event.InvoiceStatus == 'Invoice Generated'"
                  class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
                  <li>
                    <!-- <span  class="timesheet-label" style="font-style: italic;margin-bottom:5px">Invoice Generated</span> -->
                  </li>
                  <li>
                    <span style="cursor: pointer;"><span class="accept" @click="viewReport(Event.Id, 'Timesheet')">View Report</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                  </li>
                </ul>
              </div>
              <!-- <div class="col-md-12 p0" v-if="Event.IsProjectDateChanged">
                <span style="color:#FB771F;font-style: italic;font-size: 13.5px;">You cannot edit this Timesheet as your employer has updated this project's Begin date.</span>
              </div> -->
              <!--<div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <!-- <div class="col-md-6">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} day)</p>
                    <p v-else class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} days)</p>
                  </div> -->
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Hours Worked</label>
                    <p class="static">{{ Event.HoursWorked }}</p>
                  </div>
                  <div class="col-md-4 mL0"
                    v-if="Event.SubmittedDate != null && Event.SubmittedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isSubmitDate && !Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                    <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.SubmittedDate" :options="subOptions(Event)"
                        @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker>
                    </div>
                    <div v-else>
                      <p class="static">{{ Event.SubmittedDate }}<span @click.stop="editSubmittedDate(Event)"
                          v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                            style="padding-left:6px;"
                            :class="{ 'editDisable': disableSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <div class="col-md-5 pL0 mL0"
                    v-if="Event.ApprovedDate != null && Event.ApprovedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                    <label class="timesheet-label">Approval Date</label><span class="edit_date"
                      v-if="!Event.isSubmitDate && Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                    <div v-if="Event.isApprovalDate"><ob-date-time-picker :id="'date5' + Event.Id"
                        :inputvalue="Event.ApprovedDate" :options="appOptions(Event.SubmittedDate)"
                        @updated="(v) => Event.ApprovedDate = v" v-model="Event.ApprovedDate"></ob-date-time-picker>
                    </div>
                    <div v-else>
                      <p class="static">{{ Event.ApprovedDate }}<span @click.stop="editApprovedDate(Event)"
                          v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                            style="padding-left:6px;"
                            :class="{ 'editDisable': disableApprovedDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="IsEmployeeView && Event.TimesheetlatestLog != undefined && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <a href="#" style="color:red;" @click="OnCancelRequest(Event.Id, 'Timesheet')">
                      <h5>Cancel Request</h5>
                    </a>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0"
                  v-if="Event.TimesheetlatestLog.AuthorizedBy != null && Event.TimesheetlatestLog.AuthorizedBy.Name != null && Event.TimesheetlatestLog.AuthorizedBy.Name != ''">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static">{{ Event.TimesheetlatestLog.AuthorizedBy.Name }} on {{ Event.TimesheetlatestLog.DateTime }}</p>
                </div>
                <div v-if="Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.TimesheetlatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-else-if="!IsEmployeeView && Event.TimesheetlatestLog != undefined && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <span><span style="cursor: pointer;"><span class="reject"
                          @click="openRequestApproveOrRejectPopUp(Event, 'reject', 'Timesheet')">Reject</span> </span> |
                    </span>
                    <span style="cursor: pointer;"> <span class="accept"
                        @click="openRequestApproveOrRejectPopUp(Event, 'approve', 'Timesheet')">Approve</span></span>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0"
                  v-if="Event.TimesheetlatestLog.AuthorizedBy != null && Event.TimesheetlatestLog.AuthorizedBy.Name != null && Event.TimesheetlatestLog.AuthorizedBy.Name != ''">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static">{{ Event.TimesheetlatestLog.AuthorizedBy.Name }} on {{ Event.TimesheetlatestLog.DateTime }}</p>
                </div>
                <div v-if="Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.TimesheetlatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">
                      {{ item | I9URL2FileName }}
                    </span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-if="Event.ApporvedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.ApporvedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div> -->
              <!-- <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''" class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item,index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments"  v-if="item!= '' && item != null"  >
                    <span class="fileName">
                      {{item  | I9URL2FileName}}
                    </span>
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                      <div class="popper" style="padding:0px">
                          <div style="padding:10px;">
                              <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                              </span>
                              <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                              <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                          </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                  </ob-popover>
                  </div>
                </template>
              </div> -->
              <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''"
                class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                <div class="col-md-12 p0 clearfix">
                  <div class="col-md-12 p0 clearfix">
                    <span style="padding-right:0px;"><span class="circle2"></span></span>
                    <span id="distance"><span class="timesheet-title">Shared Information</span></span>
                  </div>
                  <template v-for="(item, index) in Event.TimesheetSharedLogModel">
                    <div class="col-md-12 p0 clearfix">
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Recipient Email</label>


                        <template v-for="(Item, Index) in item.SharedTo">
                          <p v-if="Index < 2 || item.showSharedLog" class="static"
                            style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                            :title="Item">{{ Item }}</p>
                        </template>
                        <a style="font-size: 11px;float: right;margin-right: 50px;"
                          v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)"
                          @click.stop="$set(item, 'showSharedLog', true)">{{ item.SharedTo.length - 2 }} more <i
                            class="fa fa-angle-down"></i> </a>
                      </div>
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Date & Time</label>
                        <p class="static"
                          style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                          :title="item.SharedDateTime">{{ item.SharedDateTime }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">
                      {{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}
                    </span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
              <!-- <div v-if="Event.InvoiceStatus != 'Invoice Generated'" class="col-md-12 p0 footer-content">
                <span v-if="!IsEditTimesheetFlag && !IsEmployeeView"><span style="cursor: pointer;"><span class="accept" @click="openRequestForReSubmitPopUp(Event)">Request for re-submit </span> </span> | </span>
                <span style="cursor: pointer;"> <span class="accept" @click="viewReport(Event.Id)">View Report</span></span>
              </div> -->
              <!-- <div v-else class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;"><span class="accept" @click="viewReport(Event.Id)">View Report</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
              </div> -->
            </div>
            <div v-if="Event.ApporvedExpenseAmount > 0">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <span style="padding-right:10px;">Expense</span>
                <span v-if="Event.ExpenselatestLog && Event.ExpenselatestLog.Status == 'EmployeeRequestedForEdit'" style="padding-right:0px;"><span class="circle5"></span></span>
                <span v-else style="padding-right:0px;"><span class="circle2"></span></span>
                <span id="distance">
                  <span v-if="Event.ExpenselatestLog && Event.ExpenselatestLog.Status == 'EmployeeRequestedForEdit'" class="timesheet-title" style="border-radius:10px;background-color:#eee7ff;color:#aa99d6;font-size:10px;padding:3px 6px">Requested for Edit</span>
                  <span v-else class="timesheet-title" style="border-radius:10px;background-color:#e7fbf2;color:#13da7c;font-size:10px;padding:3px 6px">Approved</span></span>
                <ob-dropdown type="ellipsis" class="pull-right clearfix "
                  v-if="Event.ExpenseInvoiceStatus != 'Invoice Generated'">
                  <ob-dropdown-list-item v-if="IsEmployeeView && IsEditTimesheetFlag"
                    @click.native="edit(Event, 'expense')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-else-if="!IsEmployeeView"
                    @click.native="approval(Event, true, 'expense')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="!IsEditTimesheetFlag && !IsEmployeeView && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForReSubmitPopUp(Event, 'Expense')">Request for re-submit</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="IsEmployeeView && !IsEditTimesheetFlag && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForEditPopup(Event, 'Expense')">Request for Edit</ob-dropdown-list-item>
                  <!-- <ob-dropdown-list-item @click.native="viewReport(Event.Id, 'Expense')">View Report</ob-dropdown-list-item> -->
                  <ob-dropdown-list-item v-if=" Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployeeRequestedForEdit'" @click.native="openSelectReportPopup(Event.Id, 'Expense')">View Report</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-if="!IsEmployeeView"  @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                </ob-dropdown>
                <ul v-if="Event.InvoiceStatus == 'Invoice Generated'"
                  class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
                  <li>
                    <!-- <span  class="timesheet-label" style="font-style: italic;margin-bottom:5px">Invoice Generated</span> -->
                  </li>
                  <li>
                    <span style="cursor: pointer;"><span class="accept" @click="viewReport(Event.Id, 'Expense')">View Report</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                  </li>
                </ul>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expenses Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3" v-if="Event.ApporvedExpenseAmount > 0">
                    <label class="timesheet-label">Expense Amount</label>
                    <p class="static">$ {{ Number((Event.ApporvedExpenseAmount).toFixed(2)) }}</p>
                  </div>
                  <!-- <div class="col-md-3 pL0 mL0">
                  <label class="timesheet-label">Payment Type</label>
                  <p class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;" :title="Event.PaymentType">{{NAOrValue(Event, 'PaymentType')}}</p>
                </div> -->
                  <div class="col-md-4 mL0"
                    v-if="Event.ExpenseSubmittedDate != null && Event.ExpenseSubmittedDate != ''">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isExpenseSubmitDate && !Event.isExpenseApprovalDate"
                      @click.stop="updateExpenseDates(Event)">Save</span>
                    <div v-if="Event.isExpenseSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.ExpenseSubmittedDate" :options="ExpensesubOptions(Event)"
                        @updated="(v) => Event.ExpenseSubmittedDate = v"
                        v-model="Event.ExpenseSubmittedDate"></ob-date-time-picker></div>
                    <div v-else>
                      <p class="static">{{ Event.ExpenseSubmittedDate }}<span
                          @click.stop="editExpenseSubmittedDate(Event)" v-if="!IsEmployeeView"><i
                            class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;"
                            :class="{ 'editDisable': disableExpenseSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <div class="col-md-5 pL0 mL0"
                    v-if="Event.ExpenseApprovedDate != null && Event.ExpenseApprovedDate != ''">
                    <label class="timesheet-label">Approval Date</label><span class="edit_date"
                      v-if="!Event.isExpenseSubmitDate && Event.isExpenseApprovalDate"
                      @click.stop="updateExpenseDates(Event)">Save</span>
                    <div v-if="Event.isExpenseApprovalDate"><ob-date-time-picker :id="'date5' + Event.Id"
                        :inputvalue="Event.ExpenseApprovedDate" :options="appOptions(Event.ExpenseSubmittedDate)"
                        @updated="(v) => Event.ExpenseApprovedDate = v"
                        v-model="Event.ExpenseApprovedDate"></ob-date-time-picker></div>
                    <div v-else>
                      <p class="static">{{ Event.ExpenseApprovedDate }}<span
                          @click.stop="editExpenseApprovedDate(Event)" v-if="!IsEmployeeView"><i
                            class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;"
                            :class="{ 'editDisable': disableExpenseApprovedDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="IsEmployeeView && Event.ExpenselatestLog != undefined && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <a href="#" style="color:red;" @click="OnCancelRequest(Event.Id, 'Expense')">
                      <h5>Cancel Request</h5>
                    </a>
                  </div>
                </div>
                <div
                  v-if="Event.ExpenselatestLog.AuthorizedBy != undefined && Event.ExpenselatestLog.AuthorizedBy != null && Event.ExpenselatestLog.AuthorizedBy.Name != null && Event.ExpenselatestLog.AuthorizedBy.Name != ''"
                  class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static">
                    {{ Event.ExpenselatestLog.AuthorizedBy.Name }} on {{ Event.ExpenselatestLog.DateTime }}
                  </p>
                </div>
                <div v-if="Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.ExpenselatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-else-if="!IsEmployeeView && Event.ExpenselatestLog != undefined && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <span><span style="cursor: pointer;"><span class="reject"
                          @click="openRequestApproveOrRejectPopUp(Event, 'reject', 'Expense')">Reject</span> </span> |
                    </span>
                    <span style="cursor: pointer;"> <span class="accept"
                        @click="openRequestApproveOrRejectPopUp(Event, 'approve', 'Expense')">Approve</span></span>
                  </div>
                </div>
                <div
                  v-if="Event.ExpenselatestLog.AuthorizedBy != undefined && Event.ExpenselatestLog.AuthorizedBy != null && Event.ExpenselatestLog.AuthorizedBy.Name != null && Event.ExpenselatestLog.AuthorizedBy.Name != ''"
                  class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static"> {{ Event.ExpenselatestLog.AuthorizedBy.Name }} on {{ Event.ExpenselatestLog.DateTime }}</p>
                </div>
                <div v-if="Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.ExpenselatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''"
                class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                <div class="col-md-12 p0 clearfix">
                  <div class="col-md-12 p0 clearfix">
                    <span style="padding-right:0px;"><span class="circle2"></span></span>
                    <span id="distance"><span class="timesheet-title">Shared Information</span></span>
                  </div>
                  <template v-for="(item, index) in Event.TimesheetSharedLogModel">
                    <div class="col-md-12 p0 clearfix">
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Recipient Email</label>


                        <template v-for="(Item, Index) in item.SharedTo">
                          <p v-if="Index < 2 || item.showSharedLog" class="static"
                            style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                            :title="Item">{{ Item }}</p>
                        </template>
                        <a style="font-size: 11px;float: right;margin-right: 50px;"
                          v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)"
                          @click.stop="$set(item, 'showSharedLog', true)">{{ item.SharedTo.length - 2 }} more <i
                            class="fa fa-angle-down"></i> </a>
                      </div>
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Date & Time</label>
                        <p class="static"
                          style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                          :title="item.SharedDateTime">{{ item.SharedDateTime }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template
          v-else-if="Event.CalendarType == 'TimeSheet' && Event.TimesheetType != 'TimesheetExpense' && (Event.Status == 'Saved' || Event.ExpenseStatus == 'Saved')">
          <div class="popper-content-holder">
            <div v-if="Event.HoursWorked != '' && Event.Status == 'Saved'">
              <div class="col-md-12 p0 clearfix">
                <ul class="clearfix list-unstyled list-inline">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Timesheet</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#FEDCC5;color:#F96301;font-size:10px;padding:3px 6px">In-Progress</span>
                    </li>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="IsEmployeeView">
                    <li>
                      <span v-if="Event.InvoiceStatus != 'Invoice Generated'" @click="edit(Event)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    </li>
                    <li>
                      <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </li>
                  </ul> -->
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item v-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'timesheet')">Update</ob-dropdown-list-item>
                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                </ul>
              </div>
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <!-- <div class="col-md-6">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} day)</p>
                    <p v-else class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} days)</p>
                  </div> -->
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Hours Worked</label>
                    <p class="static">{{ Event.HoursWorked }}</p>
                  </div>
                  <div class="col-md-4 pL0 mL0">
                    <label class="timesheet-label">Saved Date</label>
                    <p class="static">{{ Event.SubmittedDate }}</p>
                  </div>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                            <span
                              v-tooltip="'This document cannot be printed as browser does not support printing of documents in few formats (doc/ docx/ xls/ xlsx/ zip)'"
                              class="tooltiptext"></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-if="Event.SubmittedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.SubmittedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div> -->
              <!-- <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''" class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item,index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments"  v-if="item!= '' && item != null"  >
                    <span class="fileName">
                      {{item  | I9URL2FileName}}
                    </span>
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div style="padding:10px;">
                                <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                                <span v-tooltip="'This document cannot be printed as browser does not support printing of documents in few formats (doc/ docx/ xls/ xlsx/ zip)'" class="tooltiptext"></span>
                              </span>
                                <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                                <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                            </div>
                        </div>
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div> -->
            </div>
            <div v-if="Event.SubmittedExpenseAmount > 0">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <ul class="clearfix list-unstyled list-inline" style="margin-top:2%">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Expense</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#FEDCC5;color:#F96301;font-size:10px;padding:3px 6px">In-Progress</span>
                    </li>
                  </ul>
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item v-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'expense')">Update</ob-dropdown-list-item>
                    <ob-dropdown-list-item @click.native="openSelectReportPopup(Event.Id, 'expense')">View Report</ob-dropdown-list-item>

                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                </ul>
              </div>
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expense Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3" v-if="Event.SubmittedExpenseAmount > 0">
                    <label class="timesheet-label">Expense Amount</label>
                    <p class="static">$ {{ Number((Event.SubmittedExpenseAmount).toFixed(2)) }}</p>
                  </div>
                  <div class="col-md-5 mL0">
                    <label class="timesheet-label">Saved Date</label>
                    <p class="static">{{ Event.ExpenseSubmittedDate }}</p>
                  </div>
                </div>
              </div>
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">
                      {{ item | I9URL2FileName }}
                    </span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                            <span
                              v-tooltip="'This document cannot be printed as browser does not support printing of documents in few formats (doc/ docx/ xls/ xlsx/ zip)'"
                              class="tooltiptext"></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense'">
          <div class="popper-content-holder">
            <div v-if="Event.HoursWorked != '' && Event.Status == 'Saved'">
              <div class="col-md-12 p0 clearfix">
                <ul class="clearfix list-unstyled list-inline">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Timesheet</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#FEDCC5;color:#F96301;font-size:10px;padding:3px 6px">In-Progress</span>
                    </li>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="IsEmployeeView">
                    <li>
                      <span v-if="Event.InvoiceStatus != 'Invoice Generated'" @click="edit(Event)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    </li>
                    <li>
                      <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </li>
                  </ul> -->
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item v-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'timesheet')">Update</ob-dropdown-list-item>
                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                </ul>
              </div>
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <!-- <div class="col-md-6">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} day)</p>
                    <p v-else class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} days)</p>
                  </div> -->
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Hours Worked</label>
                    <p class="static">{{ Event.HoursWorked }}</p>
                  </div>
                  <div class="col-md-5 mL0">
                    <label class="timesheet-label">Saved Date</label>
                    <p class="static">{{ Event.SubmittedDate }}</p>
                  </div>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">
                      {{ item | I9URL2FileName }}
                    </span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                            <span
                              v-tooltip="'This document cannot be printed as browser does not support printing of documents in few formats (doc/ docx/ xls/ xlsx/ zip)'"
                              class="tooltiptext"></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-if="Event.SubmittedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.SubmittedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div> -->
              <!-- <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''" class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item,index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments"  v-if="item!= '' && item != null"  >
                    <span class="fileName">
                      {{item  | I9URL2FileName}}
                    </span>
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div style="padding:10px;">
                                <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                                <span v-tooltip="'This document cannot be printed as browser does not support printing of documents in few formats (doc/ docx/ xls/ xlsx/ zip)'" class="tooltiptext"></span>
                              </span>
                                <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                                <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                            </div>
                        </div>
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div> -->
            </div>
            <div v-else-if="Event.Status == 'Pending' && Event.HoursWorked != ''">
              <div class="col-md-12 p0 clearfix">
                <ul class="clearfix list-unstyled list-inline">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li>Timesheet</li>
                    <!-- <li style="padding-right:0px;"><span><img src="/static/Images/ic_pending.svg" /></span></li> -->
                    <li id="distance"
                      v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'">
                      <span class="timesheet-title" v-if="IsEmployeeView"
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending(request to re-submit)</span>
                      <span class="timesheet-title" v-else
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending Submission</span>
                    </li>
                    <li id="distance" v-else><span class="timesheet-title"
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending Approval</span></li>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="IsEmployeeView">
                    <li>
                      <span v-if="Event.InvoiceStatus != 'Invoice Generated'" @click="edit(Event)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    </li>
                    <li>
                      <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </li>
                  </ul> -->
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item
                      v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'"
                      @click.native="edit(Event, 'timesheet')">Resubmit</ob-dropdown-list-item>
                    <ob-dropdown-list-item v-else-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'timesheet')">Update</ob-dropdown-list-item>
                    <ob-dropdown-list-item v-if="(Event.Status == 'Approved' || Event.Status == 'Pending') && (Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployerRequestToResubmit')"
                      @click.native="openSelectReportPopup(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item>
                    <!-- <ob-dropdown-list-item v-if="Event.Status == 'Approved'"
                      @click.native="viewReport(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;"
                    v-if="!IsEmployeeView && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'"> -->
                    <ob-dropdown type="ellipsis" class="pull-right clearfix "  v-if="!IsEmployeeView && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit'">
                      <ob-dropdown-list-item @click.native="approval(Event, true, 'timesheet')">Edit</ob-dropdown-list-item>
                      <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span @click="approval(Event, true, 'timesheet')"><i class="fa fa-pencil"
                          aria-hidden="true"></i></span>
                    </li> -->
                  <!-- </ul> -->
                  <ul class="pull-right clearfix ">
                    <!-- <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span> -->
                    <template v-if="!IsEmployeeView">
                      <span
                        v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployerRequestToResubmit'">
                        <ob-dropdown type="ellipsis" class="pull-right clearfix ">
                          <ob-dropdown-list-item @click.native="approval(Event, true, 'timesheet')">Verify</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="approval(Event, false, 'timesheet')">Approve</ob-dropdown-list-item>
                                            <ob-dropdown-list-item @click.native="openSelectReportPopup(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item>

                          <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                        </ob-dropdown>
                        <!-- <span @click="approval(Event, true, 'timesheet')"
                          style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span
                          @click="approval(Event, false, 'timesheet')"
                          style="font-size: 12px;color:  #4A90E2; cursor: pointer;">Approve</span> -->
                      </span>
                    </template>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && !IsEmployeeView">
                    <li>
                      <span style="font-size: 12px;color: #4A90E2; cursor: pointer;" @click="openRemindApprover(Event)">Remind Approver</span>
                    </li>
                  </ul> -->
                </ul>
              </div>
              <!--<div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 8px;">
                <div class="col-md-3">
                  <label class="timesheet-label">Hours Worked</label>
                  <p class="static">{{ Event.HoursWorked }}</p>
                </div>
                <div class="col-md-4 mL0"
                  v-if="Event.SubmittedDate != null && Event.SubmittedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                  <label class="timesheet-label">Submitted Date</label><span class="edit_date" v-if="Event.isSubmitDate"
                    @click.stop="updateDates(Event)">Save</span>
                  <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                      :inputvalue="Event.SubmittedDate" :options="subOptions(Event)"
                      @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker>
                  </div>
                  <div v-else>
                    <p class="static">{{ Event.SubmittedDate }}<span @click.stop="Event.isSubmitDate = true"
                        v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                          style="padding-left:4px;"></i></span></p>
                  </div>
                </div>
                <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                  v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit' && Event.TimesheetlatestLog.AuthorizedBy != null && Event.TimesheetlatestLog.AuthorizedBy.Name != null && Event.TimesheetlatestLog.AuthorizedBy.Name != ''">
                  <label class="timesheet-label">Re-submit requested by</label>
                  <p class="static">{{ Event.TimesheetlatestLog.AuthorizedBy.Name }} on {{ Event.TimesheetlatestLog.DateTime }}</p>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;" v-if="Event.IsReSubmitted && Event.ReSubmittedBy.Name != null && Event.ReSubmittedBy.Name != ''">
                <div class="col-md-10 pL0 pR0">
                  <label class="timesheet-label">Re-submit requested by</label>
                  <p class="static">{{Event.ReSubmittedBy.Name}}</p>
                </div>
              </div> -->
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployerRequestToResubmit' && Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Re-submit reason</label>
                  <p class="static">{{ Event.TimesheetlatestLog.Comment }}</p>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''"
                class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                <div class="col-md-12 p0 clearfix">
                  <div class="col-md-12 p0 clearfix">
                    <span style="padding-right:0px;"><span class="circle2"></span></span>
                    <span id="distance"><span class="timesheet-title">Shared Information</span></span>
                  </div>
                  <template v-for="(item, index) in Event.TimesheetSharedLogModel">
                    <div class="col-md-12 p0 clearfix">
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Recipient Email</label>


                        <template v-for="(Item, Index) in item.SharedTo">
                          <p v-if="Index < 2 || item.showSharedLog" class="static"
                            style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                            :title="Item">{{ Item }}</p>
                        </template>
                        <a style="font-size: 11px;float: right;margin-right: 50px;"
                          v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)"
                          @click.stop="$set(item, 'showSharedLog', true)">{{ item.SharedTo.length - 2 }} more <i
                            class="fa fa-angle-down"></i> </a>
                      </div>
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Date & Time</label>
                        <p class="static"
                          style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                          :title="item.SharedDateTime">{{ item.SharedDateTime }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                  <div class="col-md-4 pR0"
                    v-if="!IsEmployeeView && Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployerRequestToResubmit'">
                    <span style="font-size: 12px;color: #4A90E2; cursor: pointer;"
                      @click="openRemindApprover(Event, 'Timesheet')">Remind Approver</span>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" 
                      :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                <template  v-else>
                  <span v-if="!Event.IsReSubmitted" >
                  <span @click="approval(Event,true)" style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span  @click="approval(Event,false)" style="font-size: 12px;color:  #4A90E2; cursor: pointer;" >Approve</span>
                  </span>
                </template>
              </div> -->
            </div>
            <div v-else-if="Event.Status == 'Approved' && Event.HoursWorked != ''">
              <div class="col-md-12 p0 clearfix">
                <span style="padding-right:10px;">Timesheet</span>
                <!-- <span style="padding-right:0px;"><span class="circle2"></span></span> -->
                <span id="distance">
                  <span class="timesheet-title" v-if="Event.TimesheetlatestLog && Event.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit'" style="border-radius:10px;background-color:#eee7ff;color:#aa99d6;font-size:10px;padding:3px 6px">Requested for Edit</span>
                  <span class="timesheet-title" v-else style="border-radius:10px;background-color:#e7fbf2;color:#13da7c;font-size:10px;padding:3px 6px">Approved</span></span>
                <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="Event.InvoiceStatus != 'Invoice Generated'">
                  <li v-if="IsEmployeeView">
                    <span v-if="IsEditTimesheetFlag" @click="edit(Event)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                  </li>
                  <li v-else>
                    <span @click="approval(Event,true)"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                  </li>
                  <li v-if="IsEmployeeView">
                    <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                  </li>
                </ul> -->
                <ob-dropdown type="ellipsis" class="pull-right clearfix "
                  v-if="Event.InvoiceStatus != 'Invoice Generated'">
                  <ob-dropdown-list-item v-if="IsEmployeeView && IsEditTimesheetFlag"
                    @click.native="edit(Event, 'timesheet')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-else-if="!IsEmployeeView"
                    @click.native="approval(Event, true, 'timesheet')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="!IsEditTimesheetFlag && !IsEmployeeView && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForReSubmitPopUp(Event, 'Timesheet')">Request for re-submit</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="IsEmployeeView && !IsEditTimesheetFlag && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForEditPopup(Event, 'Timesheet')">Request for Edit</ob-dropdown-list-item>
                  <!-- <ob-dropdown-list-item @click.native="viewReport(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item> -->
                  <ob-dropdown-list-item v-if=" Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployeeRequestedForEdit'" @click.native="openSelectReportPopup(Event.Id, 'Timesheet')">View Report</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-if="!IsEmployeeView"  @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                </ob-dropdown>
                <ul v-if="Event.InvoiceStatus == 'Invoice Generated'"
                  class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
                  <li>
                    <!-- <span  class="timesheet-label" style="font-style: italic;margin-bottom:5px">Invoice Generated</span> -->
                  </li>
                  <li>
                    <!-- <span style="cursor: pointer;"><span class="accept" @click="viewReport(Event.Id, 'Timesheet')">View Report</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span> -->
                    <span style="cursor: pointer;"><span class="accept" @click="openSelectReportPopup(Event.Id, 'Timesheet')">View Report</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                  </li>
                </ul>
              </div>
              <!-- <div class="col-md-12 p0" v-if="Event.IsProjectDateChanged">
                <span style="color:#FB771F;font-style: italic;font-size: 13.5px;">You cannot edit this Timesheet as your employer has updated this project's Begin date.</span>
              </div> -->
              <!--<div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <!-- <div class="col-md-6">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} day)</p>
                    <p v-else class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} days)</p>
                  </div> -->
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Hours Worked</label>
                    <p class="static">{{ Event.HoursWorked }}</p>
                  </div>
                  <div class="col-md-4 mL0"
                    v-if="Event.SubmittedDate != null && Event.SubmittedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isSubmitDate && !Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                    <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.SubmittedDate" :options="subOptions(Event)"
                        @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker>
                    </div>
                    <div v-else>
                      <p class="static">{{ Event.SubmittedDate }}<span @click.stop="editSubmittedDate(Event)"
                          v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                            style="padding-left:6px;"
                            :class="{ 'editDisable': disableSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <div class="col-md-5 pL0 mL0"
                    v-if="Event.ApprovedDate != null && Event.ApprovedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                    <label class="timesheet-label">Approval Date</label><span class="edit_date"
                      v-if="!Event.isSubmitDate && Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                    <div v-if="Event.isApprovalDate"><ob-date-time-picker :id="'date5' + Event.Id"
                        :inputvalue="Event.ApprovedDate" :options="appOptions(Event.SubmittedDate)"
                        @updated="(v) => Event.ApprovedDate = v" v-model="Event.ApprovedDate"></ob-date-time-picker>
                    </div>
                    <div v-else>
                      <p class="static">{{ Event.ApprovedDate }}<span @click.stop="editApprovedDate(Event)"
                          v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                            style="padding-left:6px;"
                            :class="{ 'editDisable': disableApprovedDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="IsEmployeeView && Event.TimesheetlatestLog != undefined && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <a href="#" style="color:red;" @click="OnCancelRequest(Event.Id, 'Timesheet')">
                      <h5>Cancel Request</h5>
                    </a>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0"
                  v-if="Event.TimesheetlatestLog.AuthorizedBy != null && Event.TimesheetlatestLog.AuthorizedBy.Name != null && Event.TimesheetlatestLog.AuthorizedBy.Name != ''">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static">{{ Event.TimesheetlatestLog.AuthorizedBy.Name }} on {{ Event.TimesheetlatestLog.DateTime }}</p>
                </div>
                <div v-if="Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.TimesheetlatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-else-if="!IsEmployeeView && Event.TimesheetlatestLog != undefined && Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <span><span style="cursor: pointer;"><span class="reject"
                          @click="openRequestApproveOrRejectPopUp(Event, 'reject', 'Timesheet')">Reject</span> </span> |
                    </span>
                    <span style="cursor: pointer;"> <span class="accept"
                        @click="openRequestApproveOrRejectPopUp(Event, 'approve', 'Timesheet')">Approve</span></span>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0"
                  v-if="Event.TimesheetlatestLog.AuthorizedBy != null && Event.TimesheetlatestLog.AuthorizedBy.Name != null && Event.TimesheetlatestLog.AuthorizedBy.Name != ''">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static">{{ Event.TimesheetlatestLog.AuthorizedBy.Name }} on {{ Event.TimesheetlatestLog.DateTime }}</p>
                </div>
                <div v-if="Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.TimesheetlatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-if="Event.ApporvedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.ApporvedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div> -->
              <!-- <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''" class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item,index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments"  v-if="item!= '' && item != null"  >
                    <span class="fileName">
                      {{item  | I9URL2FileName}}
                    </span>
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                      <div class="popper" style="padding:0px">
                          <div style="padding:10px;">
                              <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                              </span>
                              <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                              <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                          </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                  </ob-popover>
                  </div>
                </template>
              </div> -->
              <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''"
                class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                <div class="col-md-12 p0 clearfix">
                  <div class="col-md-12 p0 clearfix">
                    <span style="padding-right:0px;"><span class="circle2"></span></span>
                    <span id="distance"><span class="timesheet-title">Shared Information</span></span>
                  </div>
                  <template v-for="(item, index) in Event.TimesheetSharedLogModel">
                    <div class="col-md-12 p0 clearfix">
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Recipient Email</label>


                        <template v-for="(Item, Index) in item.SharedTo">
                          <p v-if="Index < 2 || item.showSharedLog" class="static"
                            style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                            :title="Item">{{ Item }}</p>
                        </template>
                        <a style="font-size: 11px;float: right;margin-right: 50px;"
                          v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)"
                          @click.stop="$set(item, 'showSharedLog', true)">{{ item.SharedTo.length - 2 }} more <i
                            class="fa fa-angle-down"></i> </a>
                      </div>
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Date & Time</label>
                        <p class="static"
                          style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                          :title="item.SharedDateTime">{{ item.SharedDateTime }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" 
                      :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
              <!-- <div v-if="Event.InvoiceStatus != 'Invoice Generated'" class="col-md-12 p0 footer-content">
                <span v-if="!IsEditTimesheetFlag && !IsEmployeeView"><span style="cursor: pointer;"><span class="accept" @click="openRequestForReSubmitPopUp(Event)">Request for re-submit </span> </span> | </span>
                <span style="cursor: pointer;"> <span class="accept" @click="viewReport(Event.Id)">View Report</span></span>
              </div> -->
              <!-- <div v-else class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;"><span class="accept" @click="viewReport(Event.Id)">View Report</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
              </div> -->
            </div>
            <div v-else-if="Event.Status == 'Rejected' && Event.HoursWorked != ''">
              <div class="col-md-12 p0 clearfix">
                <ul class="clearfix list-unstyled list-inline">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Timesheet</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#fdeae5;color:#EF4457;font-size:10px;padding:3px 6px">Rejected</span>
                    </li>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
                    <li>
                      <span @click="deleteReport(Event.Id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </li>
                  </ul> -->
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <!-- <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.TimesheetId, 'Timesheet')">Delete</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item
                      @click.native="reSubmit(Event, 'timesheet')">Re-Submit</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul v-else-if="!IsEmployeeView" class="pull-right clearfix list-unstyled list-inline"
                    style="margin:0px;"> -->
                    <ob-dropdown type="ellipsis" class="pull-right clearfix " v-else-if="!IsEmployeeView">
                      <ob-dropdown-list-item @click.native="approval(Event, true, 'timesheet')">Edit</ob-dropdown-list-item>
                      <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Timesheet')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span :class="{ 'disable-options': isTimeSheetsWriteAccessRestricted }"
                        @click="approval(Event, true, 'timesheet')"><i class="fa fa-pencil"
                          aria-hidden="true"></i></span>
                    </li> -->
                  <!-- </ul> -->
                </ul>
              </div>
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <!-- <div class="col-md-6">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} day)</p>
                    <p v-else class="static">{{Event.FromDate}} to {{Event.ToDate}} ({{Event.NoofDays}} days)</p>
                  </div> -->
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Timesheet Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Hours Worked</label>
                    <p class="static">{{ Event.HoursWorked }}</p>
                  </div>
                  <div class="col-md-4 mL0" v-if="Event.SubmittedDate != null && Event.SubmittedDate != ''">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isSubmitDate && !Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                    <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.SubmittedDate" :options="subOptions(Event)"
                        @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker>
                    </div>
                    <div v-else>
                      <p class="static">{{ Event.SubmittedDate }}<span @click.stop="editSubmittedDate(Event)"
                          v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true"
                            style="padding-left:6px;"
                            :class="{ 'editDisable': disableSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <!-- <div class="col-md-5 pL0 mL0" v-if="Event.ApprovedDate != null && Event.ApprovedDate != ''">
                  <label class="timesheet-label">Approval Date</label><span class="edit_date" v-if="!Event.isSubmitDate && Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                  <div v-if="Event.isApprovalDate"><ob-date-time-picker :id="'date5'+Event.Id" :inputvalue="Event.ApprovedDate" :options="appOptions(Event.SubmittedDate)" @updated="(v) => Event.ApprovedDate = v" v-model="Event.ApprovedDate"></ob-date-time-picker></div>
                  <div v-else><p class="static">{{Event.ApprovedDate}}<span @click.stop="editApprovedDate(Event)" v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;" :class="{ 'editDisable': disableApprovedDateEdit(Event)}"></i></span></p></div>
                </div> -->
                  <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                    v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'Rejected' && Event.TimesheetlatestLog.DateTime != null">
                    <label class="timesheet-label">Rejected Date</label>
                    <p class="static">{{ Event.TimesheetlatestLog.DateTime }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.TimesheetlatestLog != null && Event.TimesheetlatestLog.Status == 'Rejected' && Event.TimesheetlatestLog.Comment != null && Event.TimesheetlatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Reason for Rejection</label>
                  <p class="static">{{ Event.TimesheetlatestLog.Comment }}</p>
                </div>
              </div>
              <div v-if="Event.AttachmentUrls != null && Event.AttachmentUrls != ''" class="col-md-12 p0 clearfix"
                style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.AttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-if="Event.SubmittedExpenseAmount != null && Event.SubmittedExpenseAmount != '' && Event.SubmittedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.SubmittedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;"  v-else-if="Event.ApporvedExpenseAmount != null && Event.ApporvedExpenseAmount != '' && Event.ApporvedExpenseAmount > 0">
                <div class="col-md-4 pL0 pR0">
                  <label class="timesheet-label">Expense Amount</label>
                  <p class="static">$ {{Number((Event.ApporvedExpenseAmount).toFixed(2))}}</p>
                </div>
              </div> -->
              <!-- <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''" class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item,index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments"  v-if="item!= '' && item != null"  >
                    <span class="fileName">
                      {{item  | I9URL2FileName}}
                    </span>
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div style="padding:10px;">
                                <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                              </span>
                                <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                                <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                            </div>
                        </div>
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div> -->
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" 
                      :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;"><span class="accept" @click="reSubmit(Event)">Re-Submit</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
              </div> -->
            </div>
            <div v-if="Event.ExpenseStatus == 'Saved' && Event.SubmittedExpenseAmount > 0">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <ul class="clearfix list-unstyled list-inline" style="margin-top:2%">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Expense</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#FEDCC5;color:#F96301;font-size:10px;padding:3px 6px">In-Progress</span>
                    </li>
                  </ul>
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item v-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'expense')">Update</ob-dropdown-list-item>
                    <ob-dropdown-list-item @click.native="openSelectReportPopup(Event.Id, 'expense')">View Report</ob-dropdown-list-item>
                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                </ul>
              </div>
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expense Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3" v-if="Event.SubmittedExpenseAmount > 0">
                    <label class="timesheet-label">Expense Amount</label>
                    <p class="static">$ {{ Number((Event.SubmittedExpenseAmount).toFixed(2)) }}</p>
                  </div>
                  <div class="col-md-5 mL0">
                    <label class="timesheet-label">Saved Date</label>
                    <p class="static">{{ Event.ExpenseSubmittedDate }}</p>
                  </div>
                </div>
              </div>
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                            <span
                              v-tooltip="'This document cannot be printed as browser does not support printing of documents in few formats (doc/ docx/ xls/ xlsx/ zip)'"
                              class="tooltiptext"></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div>
            </div>
            <div
              v-else-if="Event.ExpenseStatus == 'Pending' && Event.SubmittedExpenseAmount != null && Event.SubmittedExpenseAmount != '' && Event.SubmittedExpenseAmount > 0">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <ul class="clearfix list-unstyled list-inline" style="margin-top:2%">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li>Expenses</li>
                    <li id="distance"
                      v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'">
                      <span class="timesheet-title" v-if="IsEmployeeView"
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending (request to re-submit)</span>
                      <span class="timesheet-title" v-else
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending Submission</span>
                    </li>
                    <li id="distance" v-else><span class="timesheet-title"
                        style="border-radius:10px;background-color:#fefae8;color:#f8d21c;font-size:10px;padding:3px 6px">Pending Approval</span></li>
                  </ul>
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <ob-dropdown-list-item
                      v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'"
                      @click.native="edit(Event, 'expense')">Resubmit</ob-dropdown-list-item>
                    <ob-dropdown-list-item v-else-if="Event.InvoiceStatus != 'Invoice Generated'"
                      @click.native="edit(Event, 'expense')">Update</ob-dropdown-list-item>
                    <!-- <ob-dropdown-list-item @click.native="viewReport(Event.Id,'Expense')">View Report</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;"
                    v-if="!IsEmployeeView && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'"> -->
                    <ob-dropdown type="ellipsis" class="pull-right clearfix " v-if="!IsEmployeeView && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit'">
                          <ob-dropdown-list-item @click.native="approval(Event, true, 'expense')">Edit</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span @click="approval(Event, true, 'expense')"><i class="fa fa-pencil"
                          aria-hidden="true"></i></span>
                    </li> -->
                  <!-- </ul> -->
                  <ul class="pull-right clearfix ">
                    <!-- <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span> -->
                    <template v-if="!IsEmployeeView">
                      <span
                        v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployerRequestToResubmit'">
                        <ob-dropdown type="ellipsis" class="pull-right clearfix ">
                          <ob-dropdown-list-item @click.native="approval(Event, true, 'expense')">Verify</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="approval(Event, false, 'expense')">Approve</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="openSelectReportPopup(Event.Id, 'Expense')">View Report</ob-dropdown-list-item>
                          <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                        </ob-dropdown>
                        <!-- <span @click="approval(Event, true, 'expense')"
                          style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span
                          @click="approval(Event, false, 'expense')"
                          style="font-size: 12px;color:  #4A90E2; cursor: pointer;">Approve</span> -->
                      </span>
                    </template>
                  </ul>
                  <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;" v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && !IsEmployeeView">
                    <li>
                      <span style="font-size: 12px;color: #4A90E2; cursor: pointer;" @click="openRemindApprover(Event)">Remind Approver</span>
                    </li>
                  </ul> -->
                </ul>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expense Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 8px;">
                <div class="col-md-3">
                  <label class="timesheet-label">ExpenseAmount</label>
                  <p class="static">$ {{ Number((Event.SubmittedExpenseAmount).toFixed(2)) }}</p>
                </div>
                <!-- <div class="col-md-3 pL0 mL0">
                  <label class="timesheet-label">Expense Type</label>
                  <p class="static">$ {{Number((Event.SubmittedExpenseAmount).toFixed(2))}}</p>
                </div> -->
                <!-- <div class="col-md-3 pL0 mL0">
                  <label class="timesheet-label">Payment Type</label>
                  <p class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;" :title="Event.PaymentType">{{NAOrValue(Event, 'PaymentType')}}</p>
                </div> -->
                <div class="col-md-4 mL0" v-if="Event.ExpenseSubmittedDate != null && Event.ExpenseSubmittedDate != ''">
                  <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                    v-if="Event.isExpenseSubmitDate" @click.stop="updateExpenseDates(Event)">Save</span>
                  <div v-if="Event.isExpenseSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                      :inputvalue="Event.ExpenseSubmittedDate" :options="ExpensesubOptions(Event)"
                      @updated="(v) => Event.ExpenseSubmittedDate = v"
                      v-model="Event.ExpenseSubmittedDate"></ob-date-time-picker></div>
                  <div v-else>
                    <p class="static">{{ Event.ExpenseSubmittedDate }}<span
                        @click.stop="Event.isExpenseSubmitDate = true" v-if="!IsEmployeeView"><i
                          class="fa fa-pencil image" aria-hidden="true" style="padding-left:4px;"></i></span></p>
                  </div>
                </div>
                <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                  v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit' && Event.ExpenselatestLog.AuthorizedBy != null && Event.ExpenselatestLog.AuthorizedBy.Name != null && Event.ExpenselatestLog.AuthorizedBy.Name != ''">
                  <label class="timesheet-label">Re-submit requested by</label>
                  <p class="static">{{ Event.ExpenselatestLog.AuthorizedBy.Name }} on {{ Event.ExpenselatestLog.DateTime }}</p>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployerRequestToResubmit' && Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Re-submit reason</label>
                  <p class="static">{{ Event.ExpenselatestLog.Comment }}</p>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;">
                <div class="col-md-3 pL0 pR0" v-if="Event.SubmittedDate != null && Event.SubmittedDate != '' && (Event.Status == 'Pending' || Event.Status == 'Approved')">
                  <label class="timesheet-label">Submitted Date</label><span class="edit_date" v-if="Event.isSubmitDate" @click.stop="updateDates(Event)">Save</span>
                  <div v-if="Event.isSubmitDate"><ob-date-time-picker :id="'date4'+Event.Id" :inputvalue="Event.SubmittedDate" :options="subOptions(Event)" @updated="(v) => Event.SubmittedDate = v" v-model="Event.SubmittedDate"></ob-date-time-picker></div>
                  <div v-else><p class="static">{{Event.SubmittedDate}}<span @click.stop="Event.isSubmitDate = true" v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:4px;"></i></span></p></div>
                </div>
              </div> -->
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <!-- <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''" class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                  <div class="col-md-12 p0 clearfix">
                      <div class="col-md-12 p0 clearfix">
                        <span style="padding-right:0px;"><span class="circle2"></span></span>
                        <span id="distance"><span class="timesheet-title"> Shared Information</span></span>
                      </div>
                      <template v-for="(item,index) in Event.TimesheetSharedLogModel">
                        <div class="col-md-12 p0 clearfix">
                          <div class="col-md-6 p0">
                            <label class="timesheet-label"> Recipient Email</label>


                            <template v-for="(Item,Index) in item.SharedTo">
                              <p v-if="Index < 2 || item.showSharedLog " class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;" :title="Item">{{Item}}</p>
                            </template>
                             <a  style="font-size: 11px;float: right;margin-right: 50px;" v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)" @click.stop="$set(item, 'showSharedLog', true)">{{item.SharedTo.length - 2 }} more <i class="fa fa-angle-down"></i> </a>
                          </div>
                          <div class="col-md-6 p0">
                            <label class="timesheet-label"> Date & Time</label>
                            <p class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;" :title="item.SharedDateTime">{{item.SharedDateTime}}</p>
                         </div>
                        </div>
                      </template>
                  </div>
              </div> -->
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                  <div class="col-md-4 pR0"
                    v-if="!IsEmployeeView && Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != '' && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployerRequestToResubmit'">
                    <span style="font-size: 12px;color: #4A90E2; cursor: pointer;"
                      @click="openRemindApprover(Event, 'Expense')">Remind Approver</span>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" 
                      :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 footer-content">
                <span style="cursor: pointer;" v-if="IsEmployeeView"><span v-if="Event.Status == 'Approved'" class="accept" @click="viewReport(Event.Id)">View Report</span><i v-if="Event.Status == 'Approved'" class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                <template  v-else>
                  <span v-if="!Event.IsReSubmitted" >
                  <span @click="approval(Event,true)" style="font-size: 12px;color:  #4A90E2;; cursor: pointer;">Verify</span> | <span  @click="approval(Event,false)" style="font-size: 12px;color:  #4A90E2; cursor: pointer;" >Approve</span>
                  </span>
                </template>
              </div> -->
            </div>
            <div v-else-if="Event.ExpenseStatus == 'Approved' && Event.ApporvedExpenseAmount > 0">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <span style="padding-right:10px;">Expense</span>
                <!-- <span style="padding-right:0px;"><span class="circle2"></span></span> -->
                <span id="distance">
                  <span v-if="Event.ExpenselatestLog && Event.ExpenselatestLog.Status == 'EmployeeRequestedForEdit'" class="timesheet-title" style="border-radius:10px;background-color:#eee7ff;color:#aa99d6;font-size:10px;padding:3px 6px">Requested for Edit</span>
                  <span v-else class="timesheet-title" style="border-radius:10px;background-color:#e7fbf2;color:#13da7c;font-size:10px;padding:3px 6px">Approved</span></span>
                <ob-dropdown type="ellipsis" class="pull-right clearfix "
                  v-if="Event.ExpenseInvoiceStatus != 'Invoice Generated'">
                  <ob-dropdown-list-item v-if="IsEmployeeView && IsEditTimesheetFlag"
                    @click.native="edit(Event, 'expense')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-else-if="!IsEmployeeView"
                    @click.native="approval(Event, true, 'expense')">Update</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="!IsEditTimesheetFlag && !IsEmployeeView && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForReSubmitPopUp(Event, 'Expense')">Request for re-submit</ob-dropdown-list-item>
                  <ob-dropdown-list-item
                    v-if="IsEmployeeView && !IsEditTimesheetFlag && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployeeRequestedForEdit'"
                    @click.native="openRequestForEditPopup(Event, 'Expense')">Request for Edit</ob-dropdown-list-item>
                  <ob-dropdown-list-item v-if=" Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status != 'EmployeeRequestedForEdit'" @click.native="openSelectReportPopup(Event.Id, 'Expense')">View Report</ob-dropdown-list-item>
                  <!-- <ob-dropdown-list-item @click.native="viewReport(Event.Id, 'Expense')">View Report</ob-dropdown-list-item> -->
                  <ob-dropdown-list-item v-if="!IsEmployeeView"  @click.native="deleteTimesheetM(Event.Id,'Expense')">Delete</ob-dropdown-list-item>
                </ob-dropdown>
                <ul v-if="Event.InvoiceStatus == 'Invoice Generated'"
                  class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
                  <li>
                    <!-- <span  class="timesheet-label" style="font-style: italic;margin-bottom:5px">Invoice Generated</span> -->
                  </li>
                  <li>
                    <span style="cursor: pointer;"><span class="accept" @click="viewReport(Event.Id, 'Expense')">View Report</span><i class="fa fa-angle-right" aria-hidden="true" style="color: #4A90E2;"></i></span>
                  </li>
                </ul>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expenses Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3" v-if="Event.ApporvedExpenseAmount > 0">
                    <label class="timesheet-label">Expense Amount</label>
                    <p class="static">$ {{ Number((Event.ApporvedExpenseAmount).toFixed(2)) }}</p>
                  </div>
                  <!-- <div class="col-md-3 pL0 mL0">
                  <label class="timesheet-label">Payment Type</label>
                  <p class="static"  style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;" :title="Event.PaymentType">{{NAOrValue(Event, 'PaymentType')}}</p>
                </div> -->
                  <div class="col-md-4 mL0"
                    v-if="Event.ExpenseSubmittedDate != null && Event.ExpenseSubmittedDate != ''">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isExpenseSubmitDate && !Event.isExpenseApprovalDate"
                      @click.stop="updateExpenseDates(Event)">Save</span>
                    <div v-if="Event.isExpenseSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.ExpenseSubmittedDate" :options="ExpensesubOptions(Event)"
                        @updated="(v) => Event.ExpenseSubmittedDate = v"
                        v-model="Event.ExpenseSubmittedDate"></ob-date-time-picker></div>
                    <div v-else>
                      <p class="static">{{ Event.ExpenseSubmittedDate }}<span
                          @click.stop="editExpenseSubmittedDate(Event)" v-if="!IsEmployeeView"><i
                            class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;"
                            :class="{ 'editDisable': disableExpenseSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <div class="col-md-5 pL0 mL0"
                    v-if="Event.ExpenseApprovedDate != null && Event.ExpenseApprovedDate != ''">
                    <label class="timesheet-label">Approval Date</label><span class="edit_date"
                      v-if="!Event.isExpenseSubmitDate && Event.isExpenseApprovalDate"
                      @click.stop="updateExpenseDates(Event)">Save</span>
                    <div v-if="Event.isExpenseApprovalDate"><ob-date-time-picker :id="'date5' + Event.Id"
                        :inputvalue="Event.ExpenseApprovedDate" :options="appOptions(Event.ExpenseSubmittedDate)"
                        @updated="(v) => Event.ExpenseApprovedDate = v"
                        v-model="Event.ExpenseApprovedDate"></ob-date-time-picker></div>
                    <div v-else>
                      <p class="static">{{ Event.ExpenseApprovedDate }}<span
                          @click.stop="editExpenseApprovedDate(Event)" v-if="!IsEmployeeView"><i
                            class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;"
                            :class="{ 'editDisable': disableExpenseApprovedDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3" v-if="Event.ApprovedDate != null && Event.ApprovedDate != ''">
                  <label class="timesheet-label">Approval Date</label><span class="edit_date" v-if="!Event.isSubmitDate && Event.isApprovalDate" @click.stop="updateDates(Event)">Save</span>
                  <div v-if="Event.isApprovalDate"><ob-date-time-picker :id="'date5'+Event.Id" :inputvalue="Event.ApprovedDate" :options="appOptions(Event.SubmittedDate)" @updated="(v) => Event.ApprovedDate = v" v-model="Event.ApprovedDate"></ob-date-time-picker></div>
                  <div v-else><p class="static">{{Event.ApprovedDate}}<span @click.stop="editApprovedDate(Event)" v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;" :class="{ 'editDisable': disableApprovedDateEdit(Event)}"></i></span></p></div>
                </div>
                </div>
              </div> -->
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="IsEmployeeView && Event.ExpenselatestLog != undefined && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <a href="#" style="color:red;" @click="OnCancelRequest(Event.Id, 'Expense')">
                      <h5>Cancel Request</h5>
                    </a>
                  </div>
                </div>
                <div
                  v-if="Event.ExpenselatestLog.AuthorizedBy != undefined && Event.ExpenselatestLog.AuthorizedBy != null && Event.ExpenselatestLog.AuthorizedBy.Name != null && Event.ExpenselatestLog.AuthorizedBy.Name != ''"
                  class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static">{{ Event.ExpenselatestLog.AuthorizedBy.Name }} on {{ Event.ExpenselatestLog.DateTime }}</p>
                </div>
                <div v-if="Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.ExpenselatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-else-if="!IsEmployeeView && Event.ExpenselatestLog != undefined && Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'EmployeeRequestedForEdit'">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Edit Request</h5>
                  </div>
                  <div class="col-md-4 pR0">
                    <span><span style="cursor: pointer;"><span class="reject"
                          @click="openRequestApproveOrRejectPopUp(Event, 'reject', 'Expense')">Reject</span> </span> |
                    </span>
                    <span style="cursor: pointer;"> <span class="accept"
                        @click="openRequestApproveOrRejectPopUp(Event, 'approve', 'Expense')">Approve</span></span>
                  </div>
                </div>
                <div
                  v-if="Event.ExpenselatestLog.AuthorizedBy != undefined && Event.ExpenselatestLog.AuthorizedBy != null && Event.ExpenselatestLog.AuthorizedBy.Name != null && Event.ExpenselatestLog.AuthorizedBy.Name != ''"
                  class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Requested by</label>
                  <p class="static">
                    {{ Event.ExpenselatestLog.AuthorizedBy.Name }} on {{ Event.ExpenselatestLog.DateTime }}
                  </p>
                </div>
                <div v-if="Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''"
                  class="col-md-12 pL0 pR0">
                  <p style="color:#333333;font-size: 11px;margin-top:4px">Request Reason:
                    <span>{{ Event.ExpenselatestLog.Comment }}</span>
                  </p>
                </div>
              </div>
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="(item, index) in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer"><img
                                :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" /></span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" /></span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer"><img
                              :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" /></span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    <!-- <span >
                      <img src="/static/Images/ic_newtab-link.svg" style="cursor: pointer;margin-bottom:7px;"/>
                    </span> -->
                  </div>
                </template>
              </div>
              <div v-if="Event.TimesheetSharedLogModel != null && Event.TimesheetSharedLogModel != ''"
                class="col-md-10 p0 clearfix" style="margin-bottom: 10px;">
                <div class="col-md-12 p0 clearfix">
                  <div class="col-md-12 p0 clearfix">
                    <span style="padding-right:0px;"><span class="circle2"></span></span>
                    <span id="distance"><span class="timesheet-title">Shared Information</span></span>
                  </div>
                  <template v-for="(item, index) in Event.TimesheetSharedLogModel">
                    <div class="col-md-12 p0 clearfix">
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Recipient Email</label>


                        <template v-for="(Item, Index) in item.SharedTo">
                          <p v-if="Index < 2 || item.showSharedLog" class="static"
                            style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                            :title="Item">{{ Item }}</p>
                        </template>
                        <a style="font-size: 11px;float: right;margin-right: 50px;"
                          v-if="item.SharedTo.length > 2 && (!item.showSharedLog || item.showSharedLog == undefined)"
                          @click.stop="$set(item, 'showSharedLog', true)">{{ item.SharedTo.length - 2 }} more <i
                            class="fa fa-angle-down"></i> </a>
                      </div>
                      <div class="col-md-6 p0">
                        <label class="timesheet-label">Date & Time</label>
                        <p class="static"
                          style="white-space: nowrap;text-overflow: ellipsis;width: 144px;overflow: hidden;font-size: 10px;"
                          :title="item.SharedDateTime">{{ item.SharedDateTime }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" 
                      :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="Event.ExpenseStatus == 'Rejected' && (Event.RejectedExpenseAmount > 0)">
              <div class="col-md-12 p0 clearfix"
                :class="(Event.CalendarType == 'TimeSheet' && Event.TimesheetType == 'TimesheetExpense') ? 'Expenseborder' : ''">
                <ul class="clearfix list-unstyled list-inline" style="margin-top:2%">
                  <ul class="clearfix list-unstyled list-inline pull-left" style="margin-left:2px;">
                    <li style="padding-right:0px;"><span>Expenses</span></li>
                    <li id="distance"><span class="timesheet-title"
                        style="border-radius:10px;background-color:#fdeae5;color:#EF4457;font-size:10px;padding:3px 6px">Rejected</span>
                    </li>
                  </ul>
                  <ob-dropdown type="ellipsis" v-if="IsEmployeeView" class="pull-right clearfix ">
                    <!-- <ob-dropdown-list-item
                      @click.native="deleteTimesheetM(Event.ExpenseId, 'Expense')">Delete</ob-dropdown-list-item> -->
                    <ob-dropdown-list-item @click.native="reSubmit(Event, 'expense')">Re-Submit</ob-dropdown-list-item>
                  </ob-dropdown>
                  <!-- <ul v-else-if="!IsEmployeeView" class="pull-right clearfix list-unstyled list-inline"
                    style="margin:0px;"> -->
                    <ob-dropdown type="ellipsis" class="pull-right clearfix " v-else-if="!IsEmployeeView">
                      <ob-dropdown-list-item @click.native="approval(Event, true, 'expense')">Edit</ob-dropdown-list-item>
                      <ob-dropdown-list-item @click.native="deleteTimesheetM(Event.Id, 'Expense')">Delete</ob-dropdown-list-item>
                    </ob-dropdown>
                    <!-- <li>
                      <span :class="{ 'disable-options': isTimeSheetsWriteAccessRestricted }"
                        @click="approval(Event, true, 'expense')"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                    </li> -->
                  <!-- </ul> -->
                </ul>
              </div>
              <!-- <div class="col-md-12 p0 clearfix"  style="margin-bottom: 8px;" v-if="Event.ThirdPartyApprover != null">
                <label class="timesheet-label">Third Party Approver</label>
                <div style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name !='' " class="ApproverNamecircle">{{getFirstLetter(Event.ThirdPartyApprover.Name)}}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" :title="Event.ThirdPartyApprover.Name">{{NAOrValue(Event.ThirdPartyApprover, 'Name')}}</span><br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;" :title="Event.ThirdPartyApprover.Email">{{NAOrValue(Event.ThirdPartyApprover, 'Email')}}</span>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12 p0 form-group" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="timesheet-label">Project Title</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.ProjectTitle">{{ NAOrValue(Event, 'ProjectTitle') }}</p>
                  </div>
                  <div class="col-md-4 mL0">
                    <label class="timesheet-label">End-Client</label>
                    <p class="static" style="white-space: nowrap;text-overflow: ellipsis;width: 92px;overflow: hidden;"
                      :title="Event.EndClientName">{{ NAOrValue(Event, 'EndClientName') }}</p>
                  </div>
                  <div class="col-md-5 pL0 mL0">
                    <label class="timesheet-label">Expense Range</label>
                    <p v-if="Event.NoofDays == 1" class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} day)</p>
                    <p v-else class="static">{{ Event.FromDate }} to {{ Event.ToDate }} ({{ Event.NoofDays }} days)</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;">
                <div class="row">
                  <div class="col-md-3"
                    v-if="Event.RejectedExpenseAmount != null && Event.RejectedExpenseAmount != '' && Event.RejectedExpenseAmount > 0">
                    <label class="timesheet-label">Expense Amount</label>
                    <p class="static">$ {{ Number((Event.RejectedExpenseAmount).toFixed(2)) }}</p>
                  </div>
                  <div class="col-md-4 mL0"
                    v-if="Event.ExpenseSubmittedDate != null && Event.ExpenseSubmittedDate != ''">
                    <label class="timesheet-label">Submitted Date</label><span class="edit_date"
                      v-if="Event.isExpenseSubmitDate && !Event.isExpenseApprovalDate"
                      @click.stop="updateExpenseDates(Event)">Save</span>
                    <div v-if="Event.isExpenseSubmitDate"><ob-date-time-picker :id="'date4' + Event.Id"
                        :inputvalue="Event.ExpenseSubmittedDate" :options="ExpensesubOptions(Event)"
                        @updated="(v) => Event.ExpenseSubmittedDate = v"
                        v-model="Event.ExpenseSubmittedDate"></ob-date-time-picker></div>
                    <div v-else>
                      <p class="static">{{ Event.ExpenseSubmittedDate }}<span
                          @click.stop="editExpenseSubmittedDate(Event)" v-if="!IsEmployeeView"><i
                            class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;"
                            :class="{ 'editDisable': disableExpenseSubmitDateEdit(Event) }"></i></span></p>
                    </div>
                  </div>
                  <!-- <div class="col-md-5 pL0 mL0" v-if="Event.ExpenseApprovedDate != null && Event.ExpenseApprovedDate != ''">
                  <label class="timesheet-label">Approval Date</label><span class="edit_date" v-if="!Event.isExpenseSubmitDate && Event.isExpenseApprovalDate" @click.stop="updateExpenseDates(Event)">Save</span>
                  <div v-if="Event.isExpenseApprovalDate"><ob-date-time-picker :id="'date5'+Event.Id" :inputvalue="Event.ExpenseApprovedDate" :options="appOptions(Event.ExpenseSubmittedDate)" @updated="(v) => Event.ExpenseApprovedDate = v" v-model="Event.ExpenseApprovedDate"></ob-date-time-picker></div>
                  <div v-else><p class="static">{{Event.ExpenseApprovedDate}}<span @click.stop="editExpenseApprovedDate(Event)" v-if="!IsEmployeeView"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:6px;" :class="{ 'editDisable': disableExpenseApprovedDateEdit(Event)}"></i></span></p></div>
                </div> -->
                  <div class="col-md-5 pL0 mL0" style="margin-bottom: 8px;"
                    v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'Rejected' && Event.ExpenselatestLog.DateTime != null">
                    <label class="timesheet-label">Rejected Date</label>
                    <p class="static">{{ Event.ExpenselatestLog.DateTime }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p0 clearfix" style="margin-bottom: 8px;"
                v-if="Event.ExpenselatestLog != null && Event.ExpenselatestLog.Status == 'Rejected' && Event.ExpenselatestLog.Comment != null && Event.ExpenselatestLog.Comment != ''">
                <div class="col-md-12 pL0 pR0">
                  <label class="timesheet-label">Reason for Rejection</label>
                  <p class="static">{{ Event.ExpenselatestLog.Comment }}</p>
                </div>
              </div>
              <div v-if="Event.ExpenseAttachmentUrls != null && Event.ExpenseAttachmentUrls != ''"
                class="col-md-12 p0 clearfix" style="margin-bottom: 10px;">
                <template v-for="item in Event.ExpenseAttachmentUrls">
                  <div class="timesheet-attachments" v-if="item != '' && item != null">
                    <span class="fileName">{{ item | I9URL2FileName }}</span>
                    <ob-popover trigger="click" :options="{ placement: 'bottom' }">
                      <div class="popper" style="padding:0px">
                        <div style="padding:10px;">
                          <span :class="{ 'cursorCls': !isFileType(item) }">
                            <span :class="{ 'hideShow': !isFileType(item) }"
                              style="display:inline-block;padding-right:10px;cursor:pointer">
                              <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32"
                                @click="printSingleDoc(item)" />
                            </span>
                          </span>
                          <span style="display:inline-block;padding:0 5px;cursor:pointer">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32"
                              @click="downloadSingleDoc(item)" />
                          </span>
                          <span style="display:inline-block;padding-left:10px;cursor:pointer">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32"
                              @click="previewSingleDoc(item)" />
                          </span>
                        </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15"
                        slot="reference"
                        style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                  </div>
                </template>
              </div>
              <div class="col-md-12" style="background-color:#e5f2ff;margin:auto;padding:15px"
                v-if="Event.ThirdPartyApprover != null && Event.ThirdPartyApprover != '' && Event.ThirdPartyApprover.Email != null && Event.ThirdPartyApprover.Email != ''">
                <div class="col-md-12 pL0 pR0">
                  <div class="col-md-8 pL0 pR0">
                    <h5>Third Party Approver</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0 pR0" style="display:flex">
                  <div style="padding-top:1.8%;padding-right:2%">
                    <span v-if="Event.ThirdPartyApprover.Name != null && Event.ThirdPartyApprover.Name != ''"
                      class="ApproverNamecircle">{{ getFirstLetter(Event.ThirdPartyApprover.Name) }}</span>
                    <span v-else>N/A</span>
                  </div>
                  <div style="font-size:11px;padding-bottom:1%">
                    <span style="color:black;font-weight:550" 
                      :title="Event.ThirdPartyApprover.Name">{{ NAOrValue(Event.ThirdPartyApprover, 'Name') }}</span>
                    <br>
                    <span style="white-space: nowrap;text-overflow: ellipsis;width: 106px;overflow: hidden;"
                      :title="Event.ThirdPartyApprover.Email">{{ NAOrValue(Event.ThirdPartyApprover, 'Email') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="Event.CalendarType == 'Holiday'">
          <div class="popper-content-holder">
            <div class="col-md-12 p0 clearfix">
              <span style="padding-right:0px;"><span class="circle1"></span></span>
              <span id="distance">
                <span class="timesheet-title">{{ Event.HolidayType == 'FederalHoliday' ? 'Federal Holiday' : 'Organization Holiday' }}</span>
              </span>
            </div>
            <div class="col-md-12 p0 clearfix" style="margin-bottom: 10px;margin-top:10px;">
              <div class="pull-left" style="margin-right: 20px;">
                <div class="form-group">
                  <label class="timesheet-label">{{ getDateFormat(Event.FromDate) }} {{ getMonthName(Event.FromDate) }} {{ getYear(Event.FromDate) }}</label>
                  <p class="static" style="font-size:12px;">{{ Event.HolidayName }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>

import utils from "Vue/Core/utils.js";
import CommonFunctionMixin from '../CommonFunctionMixin.js'

export default {
  mixins: [CommonFunctionMixin],
  props: ["EventInfo", "CurrentView", "IsEditTimesheetFlag","IsReportTypeSelectedCombined","selectedtimesheet"],
  data: function () {
    return {
      isEdit: false,
      IsRevoke: false,
      IsReject: false,
      LeaveRejectReason: '',
      LeaveRevokeReason: '',
      selectedEvent: {},
      selectedExpenseE:{},
      eventList: '',
      openRemindPopUp: false,
      openPopUpSelectReportType :false, 
      selectedtimesheet :{
        id :"",
        clickedType : ""
      },
    };
  },
  components: {

  },
  created() {
    this.assignEvent()
  },
  computed: {
    showEditButton() {
      if (this.IsEmployeeView || this.eventList.Status == 'Approved') {
        return true
      }
      else return false
    },
    Event() {
      return this.eventList
    },

    IsEmployeeView() {
      var isEmployeeView = false
      if (this.CurrentView == "dayGridMonth" || this.CurrentView == "customViewYearly") {
        isEmployeeView = true
      }
      return isEmployeeView
    }
  },
  methods: {
    isFileType(item) {
      var filename = utils.I9URL2FileName(item);
      var fileExtention = filename.split('.').pop();
      var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
      return FileTypes.includes(fileExtention)
    },
    getLeaveType(list) {
      var str = "";
      for (var i = 0; i < list.length; i++) {
        str = str + list[i].LeaveType + "(" + list[i].TotalDays + ")" + ", ";
      }
      var leaveType = str.slice(0, -2)
      return leaveType
    },
    assignEvent() {
      this.eventList = this.EventInfo;
      var result = this.eventList.map(function (el) {
        var o = Object.assign({}, el);
        o.isSubmitDate = false;
        o.isApprovalDate = false;
        o.isExpenseSubmitDate = false;
        o.isExpenseApprovalDate = false;
        return o;
      })
      this.eventList = result
    },
    daysDifference(event) {
      var start = moment(event.FromDate, "MM/DD/YYYY");
      var end = moment(event.ToDate, "MM/DD/YYYY");
      return moment.duration(end.diff(start)).asDays() + 1;
    },
    disableEdit(event) {
      if (event.IsProjectDateChanged) {
        return true
      } else {
        return false
      }
    },
    disableApprovedDateEdit(event) {
      if (event.isSubmitDate && !event.isApprovalDate) {
        return true
      }
      else {
        return false
      }
    },
    disableSubmitDateEdit(event) {
      if (!event.isSubmitDate && event.isApprovalDate) {
        return true
      }
      else {
        return false
      }
    },
    editSubmittedDate(event) {
      if (!this.disableSubmitDateEdit(event)) {
        event.isSubmitDate = true
        event.isApprovalDate = false
      }
    },
    editApprovedDate(event) {
      if (!this.disableApprovedDateEdit(event)) {
        event.isSubmitDate = false
        event.isApprovalDate = true
      }
    },
    subOptions(x) {
      var options = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        //minDate: x.FromDate,
        maxDate: moment(),
        widgetParent: '.lv1-row2',
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'auto'
        }
      }
      if (x.EvaluationDate != null && x.EvaluationDate != '') {
        let date = moment(x.ApprovedDate) < moment(x.EvaluationDate) ? x.ApprovedDate : x.EvaluationDate
        if (date != null && date != '') {
          options['maxDate'] = date
        }
      } else if (x.ApprovedDate != '' && x.ApprovedDate != null) {
        options['maxDate'] = x.ApprovedDate
      }
      return options
    },
    appOptions(date) {
      var options = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        minDate: date,
        widgetParent: '.lv1-row2',
        maxDate: moment(),
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'auto'
        }
      }
      return options
    },
    getDateFormat(date) {
      var date1 = moment(date).format('Do')
      return date1
    },
    getMonthName(date) {
      var month = moment(date).format('MMM')
      return month
    },
    getYear(date) {
      var year = moment(date).format('YYYY')
      return year
    },
    // deleteReport(id, Type) {
    //   this.$alert2("Are you sure you want to Delete ?", "Alert", {
    //     type: "confirm",
    //     yesButtonText: "Yes",
    //     noButtonText: "No",
    //     callback: (action) => {
    //       if (action === true) {
    //         this.deleteTimesheet(id, Type)
    //       }
    //     }
    //   });
    // },
    // deleteTimesheet(id, Type) {
    //   this.selectedEvent = (Type == 'expense') ? (this.eventList.filter(v => v.ExpenseId == id)[0]) : this.eventList.filter(v => v.TimesheetId == id)[0]
    //   ajax.put(`TimeSheets/Delete/${id}?employeeId=${this.selectedEvent.EmployeeId}`, {}, (res) => {
    //     if (res.data.State == true) {
    //       let localEventObj = {
    //         Id: this.selectedEvent.Id,
    //         IsPagefullLoad: true,
    //         EmployeeId: this.selectedEvent.EmployeeId,
    //         Status: "deleted",
    //         type: 'Timesheet'
    //       }
    //       this.$parent.refetchEvents(localEventObj)
    //       this.$message({
    //         type: 'success',
    //         message: "Deleted Successfully"
    //       });
    //     } else {
    //       this.$message({
    //         type: 'error',
    //         message: res.data.Message
    //       })
    //     }
    //   })
    // },
    deleteTimesheetM(id,type) {
      this.selectedEvent = this.eventList.filter(v => v.Id == id)[0]
      this.$parent.openDeleteTimesheet(id, this.selectedEvent, type);
    },
    // deleteExpense(id){
    //   this.selectedExpenseE = this.eventList.filter(v => v.Id == id)[0]
    //   this.$parent.openExpenseTimesheet(id, this.selectedExpenseE);
    // },
    openRequestForReSubmitPopUp(event, type) {
      this.$parent.openRequestForReSubmitPopup(event, type);
    },
    openRequestForEditPopup(event, type) {
      this.$parent.openRequestForEditPopup(event, type)
    },
    openRequestApproveOrRejectPopUp(event, type, TimesheetExpenseType) {
      this.$parent.openRequestApproveOrRejectPopUp(event, type, TimesheetExpenseType)
    },
    viewReport(id, clickedType) {
      this.selectedEvent = this.eventList.filter(v => v.Id == id)[0]
      var rType = ''
      if (clickedType == "Expense") {
        rType = 'ExpenseReport'
      } else {
        rType = 'TimesheetReport'
      }
      // this.$parent.onOpenApprovalreport(false,this.selectedEvent)
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.get(`TimeSheets/TimesheetReport/${id}?employeeId=${this.selectedEvent.EmployeeId}&Rtype=${rType}`, {}, (res) => {
        if (res.data.State == true) {


          window.open(res.data.ReportUrl, "_blank");

          this.$loading({}).close();
        } else {
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
      })
    },
    openSelectReportPopup(val1,val2){
      this.openPopUpSelectReportType =true
      this.selectedtimesheet.id = val1
      this.selectedtimesheet.clickedType = val2

      this.$emit("update:selectedtimesheet", this.selectedtimesheet)
      this.$emit("update:IsReportTypeSelectedCombined", true)
      
    },
    approval(event, isEvaluationFlow, type) {

      this.selectedEvent = event;
      if (isEvaluationFlow) {
        this.$loading({ 'loadingText': 'Loading...' })
        this.$parent.openEditTimesheetToApprove(this.selectedEvent, type);
      }
      else {
        var Type = (type == 'timesheet') ? 'Timesheet' : 'Expense'
        this.$parent.onApproveTimesheet(this.selectedEvent, Type);
      }

      // this.$loading({ loadingText: "Loading..." });
      // ajax.get(`/TimeSheets/${ this.selectedEvent.Id}/CanEvaluate`, {} , (res) => {
      //   if(res.data.State == true) {
      //     var IsEvaluate = res.data.CanEvaluate
      //     if(IsEvaluate)
      //     {
      //       this.$parent.onOpenApprovalreport(true,this.selectedEvent)
      //     }
      //     else
      //     {
      //       this.$parent.onOpenApprovalreport(false,this.selectedEvent)
      //     }
      //   }
      //  // this.$loading({}).close();
      // })
    },
    edit(event, type) {
      // if(!this.disableEdit(event) || event.status == "Pending"){
      this.selectedEvent = this.eventList.filter(v => v.Id == event.Id)[0]
      if (this.CurrentView == "dayGridMonth" || this.CurrentView == "customViewYearly") {
        this.$loading({ 'loadingText': 'Loading...' })
        var routerPush = this.$router.resolve({ name: `employee-addtimesheets`, query: { TimesheetId: this.selectedEvent.Id, Type: type, Status: event.TimesheetlatestLog.Status } })
        setTimeout(() => {
          this.$loading({}).close()
        }, 600)
        window.open(routerPush.href, "_self")
      }
      else {
        this.$parent.OpenEditEvaluation(this.selectedEvent);
      }
      // }
    },
    openEvaluation() {
      this.openEvaluationReport = true
    },
    approved() {
      this.openEvaluationReport = false
      this.openApprovalreport = false
    },
    onReject() {
      this.IsReject = true
    },
    reSubmit(event, type) {
      this.$loading({ 'loadingText': 'Loading...' })
      this.selectedEvent = this.eventList.filter(v => v.Id == event.Id)[0]
      var routerPush = this.$router.resolve({ name: `employee-addtimesheets`, query: { TimesheetId: this.selectedEvent.Id, Type: type } })
      setTimeout(() => {
        this.$loading({}).close()
      }, 600)
      window.open(routerPush.href, "_self")
    },
    onBackFromReject() {
      this.IsReject = false
    },
    onBackFromRevoke() {
      this.IsRevoke = false
    },
    onRevokeLeave() {
      if (this.LeaveRevokeReason != '' && this.LeaveRevokeReason != null) {
        var LeaveObj = {
          Id: this.selectedEvent.Id,
          Status: "Revoked",
          Reason: this.LeaveRevokeReason
        }
        this.AcceptOrRejectLeave(LeaveObj)
      }

    },
    onLeaveApprove(Event) {
      this.selectedEvent = Event
      var LeaveObj = {
        Id: Event.Id,
        Status: "Approved",
        Reason: this.LeaveRejectReason
      }
      this.AcceptOrRejectLeave(LeaveObj)
    },
    onRejectLeave() {
      if (this.LeaveRejectReason != '' && this.LeaveRejectReason != null) {
        var LeaveObj = {
          Id: this.selectedEvent.Id,
          Status: "Rejected",
          Reason: this.LeaveRejectReason
        }
        this.AcceptOrRejectLeave(LeaveObj)
      }
    },
    AcceptOrRejectLeave(LeaveObj) {
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.put(`/Leave/ApproveOrReject`, LeaveObj, (res) => {
        if (res.data.State == true) {
          let localEventObj = {
            Id: this.selectedEvent.Id,
            IsPagefullLoad: true,
            EmployeeId: this.selectedEvent.EmployeeId,
            Status: LeaveObj.Status,
            type: 'Leave'
          }
          this.$parent.refetchEvents(localEventObj)
          this.$message({
            type: 'success',
            message: LeaveObj.Status == "Rejected" ? "Rejected Successfully" : LeaveObj.Status == "Revoked" ? "Revoked Successfully" : "Approved Successfully"
          });
        } else {
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
        this.$loading({}).close()
      })
    },
    updateDates(list) {
      this.$loading({ loadingText: "Saving..." });
      var status = list.isSubmitDate ? 'Pending' : 'Approved';
      var date = list.isSubmitDate ? list.SubmittedDate : list.ApprovedDate;
      var isSubmitDate = list.isSubmitDate;
      ajax.put(`TimeSheets/UpdateTimeSheetDates/${list.Id}?date=${date}&status=${status}&isTimesheetdate=true`, {}, (res) => {
        if (res.data.State == true) {
          if (list.isSubmitDate) {
            list.isSubmitDate = false
          } else {
            list.isApprovalDate = false
          }
          let localEventObj = {
            Id: list.Id,
            EmployeeId: list.EmployeeId,
            isSubmitDate: isSubmitDate,
            date: date,
            IsPagefullLoad: true,
            Status: "updateDates",
            type: 'Timesheet'
          }
          this.$parent.refetchEvents(localEventObj)
        }
        this.$loading({}).close()
      })
    },
    openRemindApprover(event, type) {
      this.$parent.openRemindApproverPopUp(event, type);
    },
    getFirstLetter(name) {
      var letter = name.charAt(0)
      return letter.toUpperCase()
    },
    updateExpenseDates(list) {
      this.$loading({ loadingText: "Saving..." });
      var status = list.isExpenseSubmitDate ? 'Pending' : 'Approved';
      e ? list.ExpenseSubmittedDate : list.ExpenseApprovedDate;
      var isExpenseSubmitDate = list.isExpenseSubmitDate;
      ajax.put(`TimeSheets/UpdateTimeSheetDates/${list.Id}?date=${date}&status=${status}&isTimesheetdate=false`, {}, (res) => {
        if (res.data.State == true) {
          if (list.isExpenseSubmitDate) {
            list.isExpenseSubmitDate = false
          } else {
            list.isExpenseApprovalDate = false
          }
          let localEventObj = {
            Id: list.Id,
            EmployeeId: list.EmployeeId,
            isExpenseSubmitDate: isExpenseSubmitDate,
            date: date,
            IsPagefullLoad: true,
            Status: "updateDates",
            type: 'Timesheet'
          }
          this.$parent.refetchEvents(localEventObj)
        }
        this.$loading({}).close()
      })
    },
    ExpensesubOptions(x) {
      var options = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        //minDate: x.FromDate,
        maxDate: moment(),
        widgetParent: '.lv1-row2',
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'auto'
        }
      }
      if (x.EvaluationDate != null && x.ExpenseApprovedDate != null && x.EvaluationDate != '' && x.ExpenseApprovedDate != '') {
        let date = moment(x.ExpenseApprovedDate) < moment(x.EvaluationDate) ? x.ExpenseApprovedDate : x.EvaluationDate
        if (date != null && date != '') {
          options['maxDate'] = date
        }
      } else if (x.ExpenseApprovedDate != '' && x.ExpenseApprovedDate != null) {
        options['maxDate'] = x.ExpenseApprovedDate
      }
      return options
    },
    editExpenseSubmittedDate(event) {
      if (!this.disableExpenseSubmitDateEdit(event)) {
        event.isExpenseSubmitDate = true
        event.isExpenseApprovalDate = false
      }
    },
    editExpenseApprovedDate(event) {
      if (!this.disableExpenseApprovedDateEdit(event)) {
        event.isExpenseSubmitDate = false
        event.isExpenseApprovalDate = true
      }
    },
    disableExpenseSubmitDateEdit(event) {
      if (!event.isExpenseSubmitDate && event.isExpenseApprovalDate) {
        return true
      }
      else {
        return false
      }
    },
    disableExpenseApprovedDateEdit(event) {
      if (event.isExpenseSubmitDate && !event.isExpenseApprovalDate) {
        return true
      }
      else {
        return false
      }
    },
    OnCancelRequest(id, TimesheetExpenseType) {
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.put(`TimeSheets/CancelEditRequest?id=${id}&TimesheetExpenseType=${TimesheetExpenseType}`, {}, (res) => {
        if (res.data.State == true) {
          let localObj = {
            Id: id,
            IsPagefullLoad: true,
            EmployeeId: this.selectedEvent.EmployeeId,
            Status: "Approved",
            type: "Timesheet",
            from: "Popover"
          };
          this.$parent.refetchEvents(localObj);
          this.$message({
            type: 'success',
            message: 'Request for edit canceled successfully.'
          })

        }
        else {
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
        this.$loading({}).close()
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.edit_date {
  float: right;
  font-style: italic;
  color: #4A90E2;
  font-weight: 600;
  font-size: 11px;
  cursor: pointer;
}

.fa-pencil,
.fa-trash {
  color: #475259;
}

.fa-pencil:hover,
.fa-trash {
  color: #333333;
  cursor: pointer;
}

.popover-trigger {
  color: #4A90E2;
  cursor: pointer;
}

.section-title {
  color: #4A90E2;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
}

.control-label {
  color: #333333;
  font-size: 11px;
}

.timesheet-label {
  font-size: 11px;
  color: #333333;
}

.static {
  font-size: 11px;
  font-weight: 600;
  color: #333333;
}

.form-group {
  margin: 0;
}

.footer-content {
  border-top: 1px solid #c9ccd0 !important;
  padding: 10px 13px 9px 10px;
}

.timesheet-popover .event-block:not(:first-child) {
  border-top: 2px solid #c4c3c8 !important;
}

.timesheet-title {
  font-size: 12px;
  margin-left: 4px;
  color: #505050;
}

.fileName {
  max-width: 200px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

.timesheet-attachments {
  font-size: 12px;
  margin-top: 5px;
  margin-left: -1px;
  border: 1px solid #4A90E2 !important;
  background: #e6eff9 !important;
  padding: 1px 8px;
  display: inline-block;
  border-radius: 30px;
  float: left;
  margin-right: 2%;
}

.accept {
  font-size: 11px;
  font-weight: 600;
  color: #4A90E2;
  margin-right: 4px;
  margin-top: 2px;
}

.circle {
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: inline-block;
  color: #1F27F2;
  background-color: #1F27F2;
}

.circle2 {
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: inline-block;
  color: #13DA7C;
  background-color: #13DA7C;
}

.circle1 {
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: inline-block;
  color: #B28B61;
  background-color: #B28B61;
}

.circle4 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #EF4457;
  background-color: #EF4457;
}
.circle5 {
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: inline-block;
  color: #aa99d6;
  background-color: #eee7ff;
}
#distance {
  padding-left: 0px;
}

.revokeStyles {
  font-size: 11px;
  font-weight: 600;

  &:hover,
  &:active,
  &:focus {
    color: #4A90E2;
    text-decoration: underline !important;
  }
}

.editDisable {
  cursor: not-allowed !important;
  color: #00000057 !important;
}

.cursorCls {
  cursor: not-allowed !important;
}

.hideShow {
  pointer-events: none !important;
}

.ApproverNamecircle {
  border-radius: 50%;
  width: 34px;
  height: 34px;
  padding: 6px 10px;
  background: #7cb2f2;
  border: 1px solid #fff;
  color: #fff;
  text-align: center;
  // font: 30px Arial, sans-serif;
}

.Expenseborder {
  border-top: 1.5px dashed;
  margin-top: 10px;
}

.reject {
  font-size: 11px;
  font-weight: 600;
  color: red;
  margin-right: 4px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/Calender/TimeSheetPopover.vue